export default {
  'header.homepage': 'Homepage',
  'header.workspace': 'Workspace',
  'login.title': 'AIMATEX',
  'login.welcome': 'Welcome to AIMATEX',
  'login.description': 'AIMATEX is your AI assistant platform, providing secure and convenient services for image-to-video and more. Access all your files anytime, anywhere.',
  'login.email.placeholder': 'Email or username',
  'login.password.placeholder': 'Password',
  'login.button': 'Login',
  'login.loading': 'Logging in...',
  'login.divider': 'or login with',
  'login.signup': 'No account yet?',
  'login.signup.link': 'Sign up now',
  'login.error.default': 'Login failed, please try again later',
  'login.success': 'Login successful',
  'login.forgotPassword': 'Forgot password?',
  'login.forgotPassword.link': 'Click here to reset',
  'login.rememberPassword': 'Remember password',
  'login.social.comingSoon': 'This login method is coming soon',
  'captcha.placeholder': 'Captcha code',
  'captcha.refresh': 'Refresh captcha',
  'auth.modal.title': 'Login Required',
  'auth.modal.content': 'Your session has expired or you are not logged in. Please log in to continue.',
  'auth.modal.ok': 'Go to Login',
  'auth.modal.cancel': 'Later',
  'signup.page.title': 'Sign Up - AIMATEX',
  'signup.title': 'AIMATEX',
  'signup.welcome': 'Welcome to AIMATEX',
  'signup.description': 'Create your account and start your AI creation journey',
  'signup.feature.ai': 'AI Powered',
  'signup.feature.video': 'Video Creation',
  'signup.feature.fast': 'Fast Generation',
  'signup.feature.creative': 'Unlimited Creativity',
  'signup.username.placeholder': 'Enter username',
  'signup.email.placeholder': 'Enter email',
  'signup.password.placeholder': 'Enter password',
  'signup.confirmPassword.placeholder': 'Confirm password',
  'signup.inviteCode.placeholder': 'Invite code (optional)',
  'signup.button': 'Sign Up',
  'signup.loading': 'Signing up...',
  'signup.login': 'Already have an account?',
  'signup.login.link': 'Login now',
  'signup.error.passwordMismatch': 'Passwords do not match',
  'signup.error.default': 'Sign up failed, please try again later',
  'signup.success': 'Sign up successful',
  'resetPassword.page.title': 'Reset Password - AIMATEX',
  'resetPassword.page.description': 'Reset your AIMATEX account password',
  'resetPassword.title': 'Reset Password',
  'resetPassword.email.placeholder': 'Enter your email address',
  'resetPassword.code.placeholder': 'Enter verification code',
  'resetPassword.password.placeholder': 'Enter new password',
  'resetPassword.button': 'Reset Password',
  'resetPassword.button.loading': 'Resetting...',
  'resetPassword.backToLogin': 'Back to Login',
  'resetPassword.sendCode': 'Get Code',
  'resetPassword.sendCode.sending': 'Sending...',
  'resetPassword.sendCode.retry': 'Retry in {seconds}s',
  'resetPassword.error.emailRequired': 'Please enter your email address',
  'resetPassword.error.codeRequired': 'Please enter verification code',
  'resetPassword.error.passwordRequired': 'Please enter new password',
  'resetPassword.error.passwordLength': 'Password must be 6-20 characters',
  'resetPassword.error.codeLength': 'Verification code must be 6 digits',
  'resetPassword.success.codeSent': 'Verification code has been sent to your email',
  'resetPassword.success.reset': 'Password reset successful',
  'resetPassword.error.sendFailed': 'Failed to send verification code, please try again later',
  'resetPassword.error.resetFailed': 'Failed to reset password, please try again later',
  'resetPassword.error.incomplete': 'Please fill in all required fields',
  'resetPassword.subtitle': 'Enter your email address and new password to reset your account access.',
  'resetPassword.email.label': 'Email',
  'resetPassword.code.label': 'Verification Code',
  'resetPassword.password.label': 'New Password',
  'resetPassword.success.title': 'Reset Successful',
  'resetPassword.success.description': 'Your password has been successfully updated. You can now log in with your new password.',
  'resetPassword.goToLogin': 'Go to Login',
  'resetPassword.promo.title': 'Secure your account, Protect your creativity.',
  'resetPassword.promo.description': 'We implement bank-grade security protocols to ensure your data and creations remain exclusively yours.',
  'signup.username.rule.length': 'Username must be 4-10 characters',
  'signup.username.rule.format': 'Only letters, numbers, underscores and hyphens are allowed',
  'signup.password.rule.length': 'Password must be 6-20 characters',
  'signup.password.rule.lowercase': 'Must contain lowercase letters',
  'signup.password.rule.uppercase': 'Must contain uppercase letters',
  'signup.password.rule.number': 'Must contain numbers',
  'signup.password.rule.special': 'Must contain special characters',
  'login.verificationCode.placeholder': 'Enter verification code',
  'login.verificationCode.send': 'Get Code',
  'login.verificationCode.sending': 'Sending...',
  'login.verificationCode.retry': 'Retry in {seconds}s',
  'login.verificationCode.success': 'Verification code sent',
  'login.verificationCode.error': 'Failed to send verification code',
  'login.verificationCode.required': 'Please enter verification code',
  'login.verificationCode.invalid': 'Invalid verification code format',
  'signup.verificationCode.placeholder': 'Enter verification code',
  'signup.verificationCode.send': 'Get Code',
  'signup.verificationCode.sending': 'Sending...',
  'signup.verificationCode.retry': 'Retry in {seconds}s',
  'signup.verificationCode.success': 'Verification code sent',
  'signup.verificationCode.error': 'Failed to send code',
  'signup.verificationCode.required': 'Please enter verification code',
  'signup.verificationCode.invalid': 'Invalid verification code format',
  'signup.error.emailRequired': 'Please enter your email address',
  'signup.announcement': 'Registration function is under maintenance today!',
  'sidebar.create': 'Create',
  'sidebar.allFiles': 'All Files',
  'sidebar.starred': 'Starred',
  'sidebar.folders': 'Folders',
  'sidebar.trash': 'Trash',
  'sidebar.decrypt': 'Decrypt Tool',
  'sidebar.promptMarket': 'Prompt Market',
  'sidebar.channels': 'Channels',
  'sidebar.dailyChallenge': 'Daily Challenge',
  'sidebar.mediaTools': 'Media Tools',
  'sidebar.storageNodes': 'Storage Nodes',
  'sidebar.feedback': 'Feedback',
  'sidebar.about': 'About',
  'sidebar.productLog': 'Product Log',
  'promptMarket.title': 'Prompt Market',
  'promptMarket.subtitle': 'Explore top creators\' AI inspiration recipes and unlock unlimited creative potential',
  'promptMarket.searchPlaceholder': 'Search prompts, styles, models...',
  'promptMarket.search': 'Search',
  'promptMarket.all': 'All',
  'promptMarket.tabAll': 'All Recommended',
  'promptMarket.tabImage': 'Text to Image',
  'promptMarket.tabVideo': 'Text to Video',
  'promptMarket.tabAudio': 'Text to Music',
  'promptMarket.sortLatest': 'Latest',
  'promptMarket.sortHot': 'Popular',
  'promptMarket.sortSales': 'Best Sellers',
  'promptMarket.publish': 'Publish',
  'promptMarket.empty': 'No listings yet. Be the first to publish!',
  'promptMarket.free': 'Free',
  'promptMarket.token': 'TOKEN',
  'promptMarket.loadFailed': 'Failed to load',
  'promptMarket.listSuccess': 'Listed successfully',
  'promptMarket.listFailed': 'Failed to list',
  'create.tab.textToImage': 'Text to Image',
  'create.tab.textToVideo': 'Text to Video',
  'create.tab.imageToImage': 'Image to Image',
  'create.tab.imageToVideo': 'Image to Video',
  'create.tab.seedanceVideo': 'Seedance Video',
  'create.seedance.title': 'Seedance Image-to-Video',
  'create.seedance.subtitle': 'ByteDance Doubao Seedance 1.5, image-driven short video generation',
  'create.seedance.noModel': 'No Seedance model available. Please configure in admin.',
  'create.seedance.cameraFixed': 'Camera Fixed',
  'create.seedance.cameraFixed.true': 'Yes (Fixed)',
  'create.seedance.cameraFixed.false': 'No (Dynamic)',
  'create.seedance.watermark': 'Add Watermark',
  'create.seedance.watermark.true': 'Yes',
  'create.seedance.watermark.false': 'No',
  'create.tab.workflow': 'Workflow',
  'create.textToImage.title': 'Text to Image',
  'create.textToImage.subtitle': 'Enter a description and let AI draw the image in your mind',
  'create.textToImage.description': 'Generate images from text descriptions. This feature is under development...',
  'create.textToVideo.title': 'Text to Video',
  'create.textToVideo.subtitle': 'Enter scene descriptions and camera controls to generate high-quality videos',
  'create.textToVideo.description': 'Generate videos from text descriptions. This feature is under development...',
  'create.imageToImage.title': 'Image to Image',
  'create.imageToImage.description': 'Generate new images from reference images. This feature is under development...',
  'create.imageToVideo.title': 'Image to Video',
  'create.imageToVideo.description': 'Generate videos from reference images. This feature is under development...',
  'productLog.title': 'Product Updates',
  'productLog.feedback': 'Feedback',
  'filelist.column.name': 'Name',
  'filelist.column.size': 'Size',
  'filelist.column.updateTime': 'Modified',
  'filelist.column.recycletime': 'Recycle Time',
  'filelist.column.actions': 'Actions',
  'filelist.total': 'Total {total} items',
  'filelist.action.upload': 'Upload',
  'filelist.action.newFolder': 'New Folder',
  'filelist.action.refresh': 'Refresh',
  'filelist.action.search': 'Search files',
  'filelist.action.batchDownload': 'Download',
  'filelist.action.batchDelete': 'Delete',
  'filelist.action.download': 'Download',
  'filelist.action.preview': 'Preview',
  'filelist.action.rename': 'Rename',
  'filelist.selected': '{count} selected',
  'page.cloudDrive.title': 'My Cloud Drive',
  'page.cloudDrive.description': 'AI2OBJ Cloud Drive - Securely generate high-quality videos with AI',
  'modal.fileUpload.title': 'Upload Files',
  'modal.fileUpload.dragText': 'Drag files here, or click to upload',
  'modal.fileUpload.start': 'Start Upload',
  'modal.fileUpload.cancel': 'Cancel',
  'modal.fileUpload.clear': 'Clear List',
  'modal.fileUpload.encrypt': 'Encrypt Selected',
  'modal.fileUpload.addMore': 'Add More',
  'modal.fileUpload.remove': 'Remove',
  'modal.fileUpload.error.noSelection': 'Please select files to remove',
  'modal.fileUpload.error.noEncryption': 'Please select files to encrypt',
  'modal.fileUpload.error.noClear': 'No files to clear',
  'modal.fileUpload.error.noStart': 'No files to upload',
  'modal.fileUpload.error.noCancel': 'No uploading files to cancel',
  'modal.fileUpload.error.fileSize': 'File size exceeds limit',
  'modal.fileUpload.error.fileType': 'File type not supported',
  'modal.fileUpload.error.maxCount': 'Maximum file count exceeded',
  'modal.fileUpload.duplicate.title': 'File already exists',
  'modal.fileUpload.duplicate.skip': 'Skip',
  'modal.fileUpload.duplicate.replace': 'Replace',
  'modal.fileUpload.duplicate.rename': 'Rename',
  'modal.fileUpload.status.pending': 'Pending',
  'modal.fileUpload.status.uploading': 'Uploading',
  'modal.fileUpload.status.success': 'Success',
  'modal.fileUpload.status.error': 'Error',
  'modal.fileUpload.status.cancelled': 'Cancelled',
  'modal.fileUpload.status.duplicated': 'Duplicated',
  'modal.fileUpload.table.filename': 'Filename',
  'modal.fileUpload.table.size': 'Size',
  'modal.fileUpload.table.status': 'Status',
  'modal.fileUpload.table.progress': 'Progress',
  'modal.fileUpload.table.actions': 'Actions',
  'modal.fileUpload.speed': 'Upload Speed',
  'modal.fileUpload.remainingTime': 'Time Remaining',
  'modal.fileUpload.total.progress': 'Total Progress',
  'modal.fileUpload.error.message': 'Upload failed: {message}',
  'modal.fileUpload.confirm.clear': 'Are you sure you want to clear the upload list?',
  'modal.fileUpload.confirm.cancel': 'Are you sure you want to cancel the upload?',
  'modal.fileUpload.clear.mobile': 'Clear',
  'modal.fileUpload.encrypt.mobile': 'Encrypt',
  'modal.fileUpload.addMore.mobile': 'Add',
  'security.features.title': 'Security Features',
  'security.features.localDecryption.title': 'Local Decryption',
  'security.features.localDecryption.description': 'All decryption operations are performed locally in your browser, ensuring your file content and password never leave your device',
  'security.features.militaryEncryption.title': 'Military-grade Encryption',
  'security.features.militaryEncryption.description': 'Using AES-256-CBC encryption algorithm, the most secure symmetric encryption standard that can resist all known attacks',
  'security.features.privacyProtection.title': 'Privacy Protection',
  'security.features.privacyProtection.description': 'Strict privacy protection mechanism, no decryption passwords are saved, no file content is recorded',
  'security.features.smartDecryption.title': 'Smart Chunk Decryption',
  'security.features.smartDecryption.description': 'Using smart chunk decryption technology to significantly improve decryption speed while reducing memory usage',
  'security.features.learnMore': 'Learn More',
  'security.features.modal.title': 'AES-256-CBC Encryption Algorithm Details',
  'security.features.modal.close': 'Close',
  'decrypt.security.modal.title': 'Security Notice',
  'decrypt.security.modal.description': 'All decryption operations are performed locally, your password and file content will never be uploaded to server',
  'decrypt.security.modal.vip.title': 'Dear VIP user, you can:',
  'decrypt.security.modal.vip.feature1': 'Decrypt files of any size',
  'decrypt.security.modal.vip.feature2': 'Use smart chunk decryption for better efficiency',
  'decrypt.security.modal.vip.feature3': 'Support batch decryption of large files',
  'decrypt.security.modal.free.title': 'Important: Decryption process requires browser memory about 3x the file size.',
  'decrypt.security.modal.free.feature1': 'Free users are limited to 4GB per file',
  'decrypt.security.modal.free.feature2': 'Upgrade to VIP to decrypt files of any size',
  'decrypt.security.modal.free.feature3': 'If browser crashes, consider upgrading to use chunk decryption',
  'security.diagram.plaintext.block1': 'Plaintext Block 1',
  'security.diagram.plaintext.block2': 'Plaintext Block 2',
  'security.diagram.ciphertext.block1': 'Ciphertext Block 1',
  'security.diagram.ciphertext.block2': 'Ciphertext Block 2',
  'security.diagram.key': 'Key',
  'security.diagram.aes.encryption': 'AES Encryption',
  'security.diagram.xor.operation': 'XOR Operation',
  'security.diagram.iv': 'Initialization Vector',
  'security.features.aes.what': 'What is AES-256-CBC?',
  'security.features.aes.description': 'AES-256-CBC is an implementation of the Advanced Encryption Standard, where:',
  'security.features.aes.detail.1': 'A symmetric encryption algorithm established by the US National Institute of Standards and Technology (NIST) in 2001',
  'security.features.aes.detail.2': 'Uses 256-bit key length, providing the highest level of security',
  'security.features.aes.detail.3': 'Cipher Block Chaining (CBC) mode provides better encryption security',
  'security.features.aes.how': 'How It Works',
  'security.features.aes.process': 'The AES-256-CBC encryption process includes the following steps:',
  'security.features.aes.step1': 'Split plaintext data into fixed-size blocks (128 bits)',
  'security.features.aes.step2': 'Generate random initialization vector (IV)',
  'security.features.aes.step3': 'XOR the previous ciphertext block with current plaintext block using CBC mode',
  'security.features.aes.step4': 'Use 256-bit key to perform AES encryption on XOR result',
  'security.features.aes.example': 'Encryption Process Example:',
  'security.features.aes.security': 'Security Features',
  'security.features.aes.security.intro': 'AES-256-CBC provides multiple security guarantees:',
  'security.features.aes.security.point1': '256-bit key provides 2^256 possible combinations, impossible to brute force even with a supercomputer',
  'security.features.aes.security.point2': 'CBC mode ensures identical plaintext blocks produce different ciphertext blocks, increasing encryption randomization',
  'security.features.aes.security.point3': 'Use of initialization vector (IV) ensures that even with the same key, each encryption produces a different result',
  'security.features.aes.security.point4': 'Widely used in military, financial, and other high-security domains',
  'security.features.chunk.title': 'Smart Chunk Decryption Technology',
  'security.features.chunk.what': 'What is Smart Chunk Decryption?',
  'security.features.chunk.description': 'Smart chunk decryption is an optimized decryption technology for large files that splits large files into multiple chunks for parallel processing, with the following features:',
  'security.features.chunk.feature1.title': 'Dynamic Chunking',
  'security.features.chunk.feature1.desc': 'Automatically adjusts chunk size based on file size and system memory',
  'security.features.chunk.feature2.title': 'Parallel Processing',
  'security.features.chunk.feature2.desc': 'Multiple data blocks are decrypted simultaneously, fully utilizing multi-core CPUs',
  'security.features.chunk.feature3.title': 'Memory Optimization',
  'security.features.chunk.feature3.desc': 'Controls memory usage through stream processing to prevent memory overflow',
  'security.features.chunk.feature4.title': 'Resume Support',
  'security.features.chunk.feature4.desc': 'Supports continuing after interruption, improving fault tolerance',
  'security.features.chunk.how': 'How It Works',
  'security.features.chunk.process': 'The smart chunk decryption process includes the following steps:',
  'security.features.chunk.step1': 'File Analysis: Calculate optimal chunk size and count',
  'security.features.chunk.step2': 'Data Chunking: Split encrypted file into equal-sized chunks',
  'security.features.chunk.step3': 'Parallel Decryption: Multiple chunks are decrypted simultaneously',
  'security.features.chunk.step4': 'Stream Writing: Decrypted chunks are written to target file in sequence',
  'security.features.chunk.code': '{code}',
  'security.features.chunk.performance': 'Performance Advantages',
  'security.features.chunk.performance.intro': 'Compared to traditional one-time decryption, smart chunk decryption has significant advantages:',
  'security.features.chunk.performance.point1': 'Memory usage reduced by up to 90%, only 400MB needed for a 4GB file',
  'security.features.chunk.performance.point2': '3-5x faster decryption speed, fully utilizing multi-core CPUs',
  'security.features.chunk.performance.point3': 'Supports decryption of large files (>4GB), not limited by browser memory',
  'security.features.chunk.performance.point4': 'Visual decryption process with accurate progress and time remaining',
  'security.features.chunk.usage': 'Use Cases',
  'security.features.chunk.usage.intro': 'Smart chunk decryption is particularly suitable for the following scenarios:',
  'security.features.chunk.usage.point1': 'Decryption of large files (e.g., videos, database backups)',
  'security.features.chunk.usage.point2': 'Decryption operations on memory-constrained devices (e.g., mobile devices)',
  'security.features.chunk.usage.point3': 'Batch file decryption requiring parallel processing',
  'security.features.chunk.usage.point4': 'Decryption tasks requiring real-time progress feedback',
  'security.features.chunk.diagram': 'Smart Chunk Decryption Process Diagram',
  'decrypt.diagram.title': 'Smart Chunk Decryption Process',
  'decrypt.diagram.encryptedFile': 'Encrypted File',
  'decrypt.diagram.smartChunking': 'Smart Chunking',
  'decrypt.diagram.parallelDecryption': 'Parallel Decryption',
  'decrypt.diagram.decryptedFile': 'Decrypted File',
  'decrypt.diagram.memoryOptimization': 'Memory Usage Optimization',
  'decrypt.diagram.memoryUsage': 'Only Uses ~10% Memory',
  'decrypt.diagram.realTimeFeedback': 'Real-time Progress',
  'decrypt.fileList.column.name': 'Filename',
  'decrypt.fileList.column.status': 'Status',
  'decrypt.fileList.column.actions': 'Actions',
  'decrypt.fileList.status.pending': 'Pending',
  'decrypt.fileList.status.decrypting': 'Decrypting',
  'decrypt.fileList.status.success': 'Success',
  'decrypt.fileList.status.error': 'Error',
  'decrypt.fileList.action.info': 'Info',
  'decrypt.fileList.empty': 'No files, please add files to decrypt',
  'common.unknown': 'Unknown',
  'common.philosophy': 'Technology Should Serve the People',
  'common.speed': 'Speed',
  'common.timeSpent': 'Time Spent',
  'common.remaining': 'Remaining',
  'decrypt.upload.dragText': 'Click or drag files',
  'decrypt.upload.hint': 'Support batch .encrypted files, max {maxSize} per file',
  'decrypt.upload.button.decrypt': 'Decrypt Selected',
  'decrypt.upload.button.clear': 'Clear List',
  'decrypt.fileInfo.modal.title': 'File Information',
  'decrypt.fileInfo.modal.close': 'Close',
  'decrypt.fileInfo.name': 'File Name',
  'decrypt.fileInfo.size': 'File Size',
  'decrypt.fileInfo.type': 'File Type',
  'decrypt.fileInfo.lastModified': 'Last Modified',
  'decrypt.fileInfo.status': 'Status',
  'decrypt.fileInfo.progress': 'Progress',
  'decrypt.fileInfo.speed': 'Speed',
  'decrypt.fileInfo.timeRemaining': 'Time Remaining',
  'decrypt.fileInfo.timeSpent': 'Time Spent',
  'decrypt.fileInfo.error': 'Error Message',
  'page.decrypt.title': 'AI2OBJ File Decryption Tool',
  'page.decrypt.subtitle': 'Securely decrypt your files with zero data loss',
  'page.decrypt.helmet.title': 'File Decryption Tool - AI2OBJ',
  'page.decrypt.helmet.description': 'Secure file decryption tool - Decrypt your files locally in browser to protect your privacy',
  'filelist.modal.newFolder.title': 'New Folder',
  'filelist.modal.newFolder.placeholder': 'Enter folder name',
  'filelist.modal.newFolder.ok': 'Create',
  'filelist.modal.newFolder.cancel': 'Cancel',
  'language.selector.title': 'Select Language',
  'filelist.modal.rename.title': 'Rename',
  'filelist.modal.rename.placeholder': 'Enter new name',
  'filelist.modal.rename.ok': 'OK',
  'filelist.modal.rename.cancel': 'Cancel',
  'decrypt.password.modal.title': 'Enter Decryption Password',
  'decrypt.password.modal.placeholder': 'Enter password',
  'decrypt.password.modal.hint': 'Enter the password you set during encryption, it will only be used for local decryption',
  'decrypt.message.invalidFile': 'Please select only .encrypted files',
  'decrypt.message.duplicate': 'File "{filename}" already exists, automatically deduped',
  'decrypt.message.oversizeTitle': 'File size exceeds limit',
  'decrypt.message.oversizeContent': 'Following files exceed free user limit (4GB):',
  'decrypt.message.oversizeHint': 'Upgrade to VIP to decrypt files of any size',
  'decrypt.message.selectFile': 'Please select files to decrypt',
  'decrypt.message.enterPassword': 'Please enter decryption password',
  'decrypt.message.decryptSuccess': 'File {filename} has been saved',
  'decrypt.message.saveCancel': 'Cancelled saving file {filename}',
  'decrypt.message.downloadSuccess': 'File {filename} has been saved to downloads',
  'decrypt.message.decryptError': 'Failed to decrypt file {filename}: {error}',
  'decrypt.message.batchError': 'Batch decryption failed, please try again',
  'sideMenu.storageInfo.title': 'Storage Space',
  'sideMenu.storageInfo.usage': 'Used {used} / Total {total}',
  'sideMenu.storageStats.title': 'Storage Statistics',
  'sideMenu.storageStats.overview': 'Overview',
  'sideMenu.storageStats.totalFiles': 'Total Files',
  'sideMenu.storageStats.totalSize': 'Total Size',
  'sideMenu.storageStats.fileTypes': 'File Type Distribution',
  'sideMenu.storageStats.providers': 'Service Providers',
  'common.default': 'Default',
  'common.regionCode': 'Region Code',
  'common.nodeType': 'Node Type',
  'common.storageUsed': 'Used Space',
  'common.storageAvailable': 'Available Space',
  'common.storageLimit': 'Total Capacity',
  'common.storageUsageDetail': 'Used {used} / Total {total}',
  'common.defaultNode': 'Default Node',
  'common.confirm': 'Confirm',
  'common.cancel': 'Cancel',
  'common.latency': 'Latency',
  'common.retry': 'Retry',
  
  // Node Selection
  'cloudDrive.nodeSelect.title': 'Select Storage Node',
  'cloudDrive.nodeSelect.addNode': 'Add Storage Node',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'Confirm Delete Node',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'Are you sure to delete node "{nodeName}"? This action cannot be undone!',
  'cloudDrive.nodeSelect.deleteSuccess': 'Node deleted successfully',
  'cloudDrive.nodeSelect.deleteFailed': 'Failed to delete node',
  
  // Node Creation
  'cloudDrive.nodeCreate.title': 'Add Storage Node',
  'cloudDrive.nodeCreate.selectProvider': 'Select Cloud Provider',
  'cloudDrive.nodeCreate.nodeName': 'Node Name',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'Leave empty to use default name',
  'cloudDrive.nodeCreate.nameMaxLength': 'Node name cannot exceed 50 characters',
  'cloudDrive.nodeCreate.noProviders': 'No available cloud providers',
  'cloudDrive.nodeCreate.pingLatency': 'Latency {value} ms',
  'cloudDrive.nodeCreate.pingTesting': 'Testing latency...',
  'cloudDrive.nodeCreate.pingFailed': 'Latency test failed',
  'cloudDrive.nodeCreate.pingUnavailable': 'Latency not available',
  'cloudDrive.nodeCreate.sortByLatency': 'Sort by latency',
  'cloudDrive.nodeCreate.selectRegion': 'Select Region',
  'cloudDrive.nodeCreate.selectedRegion': 'Selected Region',
  'cloudDrive.nodeCreate.noRegions': 'No regions available',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'Please select a cloud provider',
  'cloudDrive.nodeCreate.selectProviderRequired': 'Please select a cloud provider first',
  'cloudDrive.nodeCreate.selectRegionRequired': 'Please select a region first',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'Failed to load cloud providers list',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'Failed to load regions list',
  'cloudDrive.nodeCreate.nodeType': 'Node Type',
  'cloudDrive.nodeCreate.nodeType.standard': 'Standard Storage',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'Low Frequency Storage',
  'cloudDrive.nodeCreate.nodeType.archive': 'Archive Storage',
  'cloudDrive.nodeCreate.storageLimit': 'Storage Limit',
  'cloudDrive.nodeCreate.storageLimitRequired': 'Please enter storage limit',
  'cloudDrive.nodeCreate.storageLimitMin': 'Storage limit cannot be less than 1GB',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'Enter storage limit (GB)',
  'cloudDrive.nodeCreate.success': 'Storage node created successfully',
  'cloudDrive.nodeCreate.failed': 'Failed to create storage node',
  
  // Node Edit
  'cloudDrive.nodeEdit.title': 'Edit Node',
  'cloudDrive.nodeEdit.name': 'Node Name',
  'cloudDrive.nodeEdit.nameRequired': 'Please enter node name',
  'cloudDrive.nodeEdit.nameMaxLength': 'Node name cannot exceed 50 characters',
  
  // TextToImage page internationalization
  'create.prompt': 'Prompt',
  'create.prompt.placeholder': 'e.g., a cyberpunk cat walking in space, neon background, high detail...',
  'create.prompt.required': 'Please enter a prompt',
  'create.prompt.generate': 'AI Generate Prompt',
  'create.prompt.enrich': 'AI Enrich Prompt',
  'create.prompt.generate.success': 'Prompt generated successfully!',
  'create.prompt.generate.error': 'Failed to generate prompt, please try again',
  'create.prompt.generate.empty': 'No prompt generated, please try again',
  'create.prompt.restore': 'Restore',
  'create.prompt.restore.success': 'Restored to original prompt',
  'create.prompt.restore.tooltip': 'Restore to the prompt before AI generation/enrichment',
  'create.negativePrompt': 'Negative Prompt',
  'create.ratio': 'Aspect Ratio',
  'create.style': 'Art Style',
  'create.batchSize': 'Batch Size',
  'create.batchSize.tooltip': 'How many images to generate at once',
  'create.empty': 'No generations yet. Enter your inspiration!',
  'create.resolution': 'Resolution',
  'create.resolution.tooltip': 'Select image resolution; takes priority over aspect ratio',
  'create.resolution.placeholder': 'Select resolution (optional)',
  'create.generate': 'Generate Now',
  'create.negativePrompt.tooltip': 'Elements you don\'t want in the image',
  'create.negativePrompt.placeholder': 'e.g., blur, low quality, deformed fingers...',
  'create.generating': 'Generating...',
  'create.generating.waiting': 'AI is creating, please wait...',
  'create.result.title': 'Generated Results',
  'create.downloadAll': 'Download All',
  'create.aspectRatio.1:1': '1:1 (Square)',
  'create.aspectRatio.16:9': '16:9 (Landscape)',
  'create.aspectRatio.9:16': '9:16 (Portrait)',
  'create.aspectRatio.21:9': '21:9 (Cinema)',
  'create.aspectRatio.4:3': '4:3 (Classic)',
  'create.style.general': 'General',
  'create.style.anime': 'Anime',
  'create.style.realistic': 'Realistic',
  'create.style.3d-render': '3D Render',
  'create.style.cyberpunk': 'Cyberpunk',
  'create.settings.loadFailed': 'Failed to load creation type settings, showing all options',
  'create.settings.error': 'Failed to load settings, showing all options',
  'create.noAvailableTabs': 'No available creation types',
  'create.network.error.title': 'Network Connection Error',
  'create.network.error.description': 'Unable to load creation type settings. Please check your network connection and refresh the page',
  'create.network.error.refresh': 'Refresh Page',
  
  // TextToVideo page internationalization
  'create.prompt.video': 'Video Scene Description (Prompt)',
  'create.prompt.video.placeholder': 'e.g., An astronaut dog dancing on the moon surface, 8K, cinematic lighting, surrealism.',
  'create.prompt.video.required': 'Please enter a video scene description',
  'create.generate.video': 'Generate Video Now',
  'create.video.ratio': 'Video Aspect Ratio',
  'create.video.camera': 'Camera Motion',
  'create.video.duration': 'Video Duration (seconds)',
  'create.video.format': 'Output Format',
  'create.cameraMotion.none': 'None',
  'create.cameraMotion.zoomIn': 'Zoom In',
  'create.cameraMotion.dollyOut': 'Dolly Out',
  'create.cameraMotion.panLeft': 'Pan Left',
  'create.cameraMotion.tiltUp': 'Tilt Up',
  'create.cameraMotion.orbital': '360° Orbital',
  'create.negativePrompt.video.placeholder': 'e.g., watermarks, flickering, low resolution, blurry characters...',
  'create.sora.thinking': 'Sora is thinking...',
  'create.video.analyzing': 'Analyzing image and prompt, AI is creating...',
  'create.video.info': 'Duration: {duration}s | Ratio: {ratio}',
  'create.video.preview': 'Video Preview',
  'create.video.result': 'Final Video Preview',
  'create.video.empty': 'Generated results will be displayed here',
  'create.download': 'Download Video',
  'create.video.generate.success': 'Video generation task submitted, please wait for the result',
  'create.video.generate.failed': 'Video generation failed, please try again',
  'create.video.generate.cancel': 'Cancel Generation',
  'create.video.generate.cancelled': 'Video generation cancelled',
  'create.video.generate.cancelled.polling': 'Task polling cancelled',
  'create.video.generate.queued': 'Video generation task submitted, queuing...',
  'create.video.generate.noUrl': 'Video generation completed, but video URL not found',
  'create.video.status.checkFailed': 'Failed to check task status',
  'create.video.generate.processing': 'Video generation task submitted, processing...',
  'create.video.taskQueue': 'Task Queue',
  'create.video.polling': 'Generating video, please wait...',
  'create.video.ratio.invalid': 'Please select a video aspect ratio supported by the model',
  'create.duration.format': '{duration}s',
  'create.duration.4s': '4s',
  'create.duration.8s': '8s',
  'create.duration.15s': '15s',
  'create.estimated.price': 'Est: {price}',
  'create.model.select': 'Select Model',
  'create.model.select.image.placeholder': 'Please select an image generation model',
  'create.model.loading': 'Loading models...',
  'create.model.loadFailed': 'Failed to load model list',
  'create.model.family.select': 'Select Model Family',
  'create.model.family.select.placeholder': 'Please select a model family',
  'create.model.family.loadFailed': 'Failed to load model families',
  'create.style.select.placeholder': 'Please select an art style (optional, defaults to family model)',
  'create.model.style.loadFailed': 'Failed to load style models',
  'create.model.description': 'Model Description',
  'create.model.aspectResolution': 'Aspect Resolution',
  'create.model.fps': 'Frame Rate',
  'create.model.features': 'Supported Features',
  'create.model.feature.cameraMotion': 'Camera Motion',
  'create.model.feature.img2video': 'Image to Video',
  'create.model.feature.videoEdit': 'Video Edit',
  'create.model.price.perSecond': '/sec',
  'create.model.price.perImage': '/image',
  'create.model.detail': 'Details',
  'create.image.format': 'Output Format',
  'create.history.title': 'Generation History',
  'create.history.refresh': 'Refresh',
  'create.history.empty': 'No generation history',
  'create.history.total': 'Total {total} records',
  'create.history.status.queued': 'Queued',
  'create.history.status.processing': 'Processing',
  'create.history.status.success': 'Success',
  'create.history.status.failed': 'Failed',
  'create.history.status.timeout': 'Timeout',
  'create.history.failed.noImage': 'Generation Failed',
  'create.history.failed.noVideo': 'Generation Failed',
  'create.history.downloadAll.start': 'Starting download of {count} images',
  'create.history.downloadAll.tooltip': 'Download all {count} images',
  'create.history.download.tooltip': 'Download image',
  'create.history.detail.tooltip': 'View Details',
  'create.history.noPrompt': 'No prompt',
  'create.history.deleteConfirm.title': 'Confirm Delete',
  'create.history.deleteConfirm.content': 'Are you sure you want to delete this task? This action cannot be undone.',
  'create.history.deleteSuccess': 'Deleted successfully',
  'create.history.deleteFailed': 'Failed to delete',
  'create.taskDetail.title': 'Task Details',
  'create.taskDetail.loading': 'Loading...',
  'create.taskDetail.loadFailed': 'Failed to load task details',
  'create.taskDetail.noData': 'No data available',
  'create.taskDetail.basicInfo': 'Basic Information',
  'create.taskDetail.model': 'Model',
  'create.taskDetail.taskType': 'Task Type',
  'create.taskDetail.createTime': 'Create Time',
  'create.taskDetail.duration': 'Generation Duration',
  'create.taskDetail.prompt': 'Prompt',
  'create.taskDetail.error': 'Error Message',
  'create.taskDetail.outputFiles': 'Output Files',
  'create.taskDetail.downloadAll': 'Download All',
  'create.taskDetail.downloadAll.start': 'Starting download of {count} images',
  'create.taskDetail.modelInfo': 'Model Information',
  'create.taskDetail.defaultResolution': 'Default Resolution',
  'create.taskDetail.maxResolution': 'Max Resolution',
  'create.taskDetail.aspectRatios': 'Supported Aspect Ratios',
  'create.taskDetail.formats': 'Supported Formats',
  'create.taskDetail.prompt.copied': 'Prompt copied',
  'create.taskDetail.liked': 'Liked',
  'create.taskDetail.like': 'Like',
  'create.taskDetail.collected': 'Collected',
  'create.taskDetail.collect': 'Collect',
  'create.taskDetail.linkCopied': 'Link copied',
  'create.taskDetail.share': 'Share',
  'create.taskDetail.outputs': 'Outputs',
  'create.taskDetail.preview': 'Preview',
  'create.taskDetail.download': 'Download',
  'create.taskDetail.generationFailed': 'Generation Failed',
  'create.taskDetail.generating': 'Generating...',
  'create.taskDetail.promptLabel': 'Prompt',
  'create.taskDetail.copy': 'Copy',
  'create.taskDetail.executionStats': 'Execution Stats',
  'create.taskDetail.creditsCost': 'Credits Cost',
  'create.taskDetail.modelSpecs': 'Model Specs',
  'create.taskDetail.capabilities': 'Capabilities',
  'create.taskDetail.supportedRatios': 'Supported Ratios',
  'create.taskDetail.dataError': 'Data Error',
  'create.taskDetail.more': 'More',
  'create.taskDetail.downloading': 'Downloading...',
  'create.taskDetail.points': 'pts',
  'create.taskDetail.seconds': 's',
  'create.taskDetail.status.success': 'SUCCESS',
  'create.taskDetail.status.failed': 'FAILED',
  'create.taskDetail.status.processing': 'PROCESSING',
  'create.taskDetail.status.queued': 'QUEUED',
  'create.taskDetail.status.generating': 'GENERATING',
  'create.taskDetail.durationLabel': 'Duration',
  'create.taskDetail.taskParams': 'Task Parameters',
  'create.taskDetail.aspectRatio': 'Aspect Ratio',
  'create.taskDetail.inputType': 'Input Type',
  'create.taskDetail.modelCode': 'Model Code',
  'create.taskDetail.regenerate': 'Regenerate',
  'create.taskDetail.feature.developing': 'Feature under development',
  'create.taskDetail.result': 'Generation Result',
  'create.taskDetail.copyPrompt': 'Copy Prompt',
  'create.taskDetail.imageDimensions': 'Dimensions',
  'create.taskDetail.fileSize': 'File Size',
  'create.taskDetail.loadingImageInfo': 'Loading image info...',
  'create.waitingTask.queue': 'Task Queue',
  'create.waitingTask.empty': 'No tasks in progress',
  'create.waitingTask.generating': 'Generating...',
  'create.waitingTask.queued': 'Queued',
  'create.waitingTask.cancel': 'Cancel Task',
  // HistorySection new internationalization
  'create.history.copyPrompt': 'Copy Prompt',
  'create.history.download': 'Download',
  'create.history.delete': 'Delete',
  'create.history.generating': 'Generating...',
  'create.history.generationFailed': 'Generation Failed',
  'create.history.noPreview': 'No Preview',
  // ImageToVideo new internationalization
  'create.i2v.fileType.error': 'Please select an image file',
  'create.i2v.fileSize.error': 'Image file size cannot exceed 10MB',
  'create.i2v.imageSize.error': 'Image height must be at least {minHeight}px, current image size is {width}x{height}px',
  'create.i2v.fileRead.error': 'Failed to read image',
  'create.i2v.replaceImage': 'Replace Image',
  'create.i2v.upload.supportedFormats': 'Supports JPG, PNG, WebP, JFIF',
  'create.i2v.upload.required': 'Please upload a reference image',
  'create.i2v.upload': 'Upload Reference Image (Starting Frame)',
  'create.i2v.upload.click': 'Click or drag to upload',
  'create.i2v.prompt.required': 'Please enter a motion guidance description',
  'create.i2v.uploading.image': 'Uploading image to cloud...',
  'create.i2v.upload.success': 'Image uploaded successfully',
  'create.i2v.upload.failed': 'Image upload failed, please try again',
  'create.i2v.original': 'Original (Starting Frame)',
  'create.i2v.result': 'Generation Comparison',
  'create.i2v.empty': 'Generated results and original image comparison will be displayed here',
  'create.generate.i2v': 'Start Generating Video',
  'create.prompt.i2v.placeholder': 'e.g., Make the person in the image start walking, leaves in the background swaying in the wind...',
  'create.prompt.enhance.tooltip': 'AI enrich prompt to make the description more detailed and vivid',
  'create.prompt.enhance': 'AI Enrich',
  'create.prompt.enhance.empty': 'Please enter a base prompt first',
  'create.prompt.enhance.success': 'Prompt enriched successfully!',
  'create.prompt.enhance.empty.result': 'No enriched prompt generated, please try again',
  'create.prompt.enhance.error': 'Failed to enrich prompt, please try again',
  'create.prompt.version.history': 'Version History',
  'create.prompt.version.history.tooltip': 'View prompt version history',
  // TaskDetailModal new internationalization
  'create.taskDetail.unnamedTask': 'Unnamed Task',
  'create.taskDetail.prompt.title': 'Prompt',
  'create.taskDetail.tokenCost': 'Token Cost',
  'create.taskDetail.publish': 'Publish to Community',
  'create.taskDetail.selectCover': 'Select Cover',
  'create.taskDetail.selectChannel': 'Select Channel',
  'create.taskDetail.selectChallenge': 'Select Challenge',
  'create.taskDetail.publishSuccess': 'Published successfully',
  'create.taskDetail.loadChannelsFailed': 'Failed to load channels',
  'create.taskDetail.loadChallengesFailed': 'Failed to load challenges',
  'create.taskDetail.publishFailed': 'Failed to publish',
  'create.taskDetail.daysLeft': '{days} days left',
  // ModelDetailModal new internationalization
  'create.model.capability.t2v': 'T2V (Text to Video)',
  'create.model.capability.img2video': 'Img2Video',
  'create.model.capability.videoEdit': 'Video Edit',
  'create.model.capability.characterConsistency': 'Character Consistency',
  'create.model.capability.reference': 'Reference',
  'create.model.capability.cameraMotion': 'Camera Motion',
  'create.model.aspectRatios': 'Aspect Ratios',
  'create.model.resolution': 'Resolution',
  'create.model.resolution.default': 'Default',
  'create.model.resolution.max': 'Max',
  'create.model.duration': 'Duration',
  'create.model.formats': 'Formats',
  'create.model.like': 'Like',
  'create.model.liked': 'Liked',
  'create.model.unliked': 'Unliked',
  'create.model.favorite': 'Favorite',
  'create.model.favorited': 'Favorited',
  'create.model.unfavorited': 'Unfavorited',
  'create.model.share': 'Share',
  'create.model.linkCopied': 'Link copied',
  'create.model.capabilities': 'Capabilities',
  'create.model.free': 'Free',
  'create.model.tokenCost.display': '{count} token',
  // Aspect Ratio internationalization
  'create.aspectRatio.portrait': 'Portrait',
  'create.aspectRatio.landscape': 'Landscape',
  'create.video.ratio.placeholder': 'Please select video aspect ratio',
  'create.video.format.placeholder': 'Please select output format',
  'create.video.style': 'Video Style',
  'create.video.style.tooltip': 'Select video generation style',
  'create.video.style.placeholder': 'Please select video style',
  'create.video.quality': 'Video Quality',
  'create.video.quality.tooltip': 'Select video generation quality',
  'create.video.quality.placeholder': 'Please select video quality',
  'create.duration.select.placeholder': 'Please select video duration',
  'create.model.select.placeholder': 'Please select a model first',
  'create.aspectRatio.3:4': '3:4 (Portrait Classic)',
  'video.not.supported': 'Your browser does not support video playback.',
  // UnderDevelopment Internationalization
  'underDevelopment.comingSoon': 'Coming Soon',
  'underDevelopment.title': 'Feature Under Development',
  'underDevelopment.subtitle': 'We are working hard to develop this feature, please stay tuned!',
  'underDevelopment.backHome': 'Back to Home',
  'underDevelopment.goBack': 'Go Back',
  // UserMenu Internationalization
  'userMenu.email.notBound': 'Email not bound',
  'userMenu.status.verified': 'Verified',
  'userMenu.status.guest': 'Guest',
  'userMenu.level': 'Level',
  'userMenu.member.vip1': 'Basic Member',
  'userMenu.member.vip2': 'Silver Member',
  'userMenu.member.vip3': 'Gold Member',
  'userMenu.member.vip4': 'Diamond Member',
  'userMenu.member.vip5': 'Ultimate Member',
  'userMenu.recharge': 'Recharge Now',
  'userMenu.community': 'Community',
  'userMenu.group.account': 'Account Settings',
  'userMenu.group.assets': 'Assets & Orders',
  'userMenu.group.workspace': 'Workspace',
  'userMenu.group.support': 'Support',
  'userMenu.item.profile': 'Profile',
  'userMenu.item.settings': 'Settings',
  'userMenu.item.security': 'Security',
  'userMenu.item.privacy': 'Privacy',
  'userMenu.item.wallet': 'My Wallet',
  'userMenu.item.subscription': 'Subscription',
  'userMenu.item.orders': 'Order History',
  'userMenu.item.works': 'My Works',
  'userMenu.item.notifications': 'Notifications',
  'userMenu.item.help': 'Help Center',
  'userMenu.item.invite': 'Invite Friends',
  'userMenu.item.feedback': 'Feedback',
  'userMenu.item.about': 'About Us',
  'userMenu.item.community': 'Community',
  'userMenu.logout': 'Logout',
  'userMenu.status.reviewing': 'Under Review',
  'userMenu.status.rejected': 'Rejected',
  // Verification Internationalization
  'verification.title': 'Identity Verification',
  'verification.subtitle': 'Please fill in your real information and upload ID photos. We will complete the review within 1-3 business days',
  'verification.back': 'Back',
  'verification.back.profile': 'Back to Profile',
  'verification.cancel': 'Cancel',
  'verification.submit': 'Submit',
  'verification.submit.success': 'Submitted successfully, awaiting review',
  'verification.submit.error': 'Submission failed, please try again later',
  'verification.verified.title': 'Identity Verified',
  'verification.verified.desc': 'Your identity verification has been approved',
  'verification.step.info': 'Fill Information',
  'verification.step.upload': 'Upload Documents',
  'verification.step.complete': 'Complete',
  'verification.info.title': 'Notice',
  'verification.info.desc': 'Please ensure that the uploaded ID photos are clear and complete. Your personal information will be strictly confidential and only used for identity verification.',
  'verification.form.realName.label': 'Real Name',
  'verification.form.realName.required': 'Please enter your real name',
  'verification.form.realName.invalid': 'Invalid name format',
  'verification.form.realName.placeholder': 'Please enter your real name as shown on ID',
  'verification.form.idType.label': 'ID Type',
  'verification.form.idType.required': 'Please select ID type',
  'verification.form.cardNum.label': 'ID Number',
  'verification.form.cardNum.required': 'Please enter ID number',
  'verification.form.cardNum.invalid': 'Invalid ID number format',
  'verification.form.cardNum.placeholder': 'Please enter your ID number',
  'verification.form.idCardFront.label': 'ID Front',
  'verification.form.idCardBack.label': 'ID Back',
  'verification.upload.required': 'Please upload ID photos',
  'verification.upload.sizeLimit': 'File size cannot exceed 5MB',
  'verification.upload.front.text': 'Click or drag to upload ID front',
  'verification.upload.back.text': 'Click or drag to upload ID back',
  'verification.upload.hint': 'Supports JPG, PNG formats, max 5MB per file',
  'verification.upload.reupload': 'Re-upload',
  'verification.reviewing.title': 'Under Review',
  'verification.reviewing.desc': 'Your identity verification is under review, expected to complete within 1-3 business days',
  'verification.rejected.title': 'Verification Failed',
  'verification.rejected.desc': 'Your identity verification was not approved',
  'verification.rejected.reason': 'Rejection Reason',
  'verification.resubmit': 'Resubmit',
  'verification.info.name': 'Name: ',
  'verification.info.idType': 'ID Type: ',
  'verification.info.idNumber': 'ID Number: ',
  'verification.info.country': 'Country/Region: ',
  'verification.info.submitTime': 'Submit Time: ',
  'verification.info.verifyTime': 'Verify Time: ',
  // Profile Page Internationalization
  'profile.editProfile': 'Edit Profile',
  'profile.creditScore': 'Credit Score',
  'profile.level': 'Level',
  'profile.balance': 'Balance',
  'profile.tab.basic': 'Basic Info',
  'profile.tab.account': 'Account Assets',
  'profile.section.personal': 'Personal Info',
  'profile.section.contact': 'Contact',
  'profile.section.wallet': 'USDT Wallet',
  'profile.label.username': 'Username',
  'profile.label.realName': 'Real Name',
  'profile.label.accountStatus': 'Account Status',
  'profile.label.phone': 'Phone Number',
  'profile.label.email': 'Email',
  'profile.label.registerTime': 'Register Time',
  'profile.label.availableBalance': 'Available Balance',
  'profile.label.frozenAmount': 'Frozen Amount',
  'profile.value.notVerified': 'Not Verified',
  'profile.value.notBound': 'Not Bound',
  'profile.value.noAddress': 'No TRC20 Address',
  'profile.value.noDescription': 'No description yet',
  'profile.status.normal': 'Normal',
  'profile.status.disabled': 'Disabled',
  'profile.tooltip.verified': 'Verified',
  'profile.tooltip.unverified': 'Verify Now',
  'profile.banner.construction': 'This page is under construction...',
  'profile.modal.title': 'Edit Profile',
  'profile.modal.cancel': 'Cancel',
  'profile.modal.save': 'Save Changes',
  'profile.modal.avatarSection': 'Avatar Settings',
  'profile.modal.basicSection': 'Basic Information',
  'profile.modal.contactSection': 'Contact Information',
  'profile.modal.changeAvatar': 'Change Avatar',
  'profile.modal.avatarHint': 'Supports JPG, PNG formats, max 2MB',
  'profile.modal.nickname': 'Nickname',
  'profile.modal.nicknamePlaceholder': 'Enter your nickname',
  'profile.modal.description': 'Bio',
  'profile.modal.descriptionPlaceholder': 'Introduce yourself...',
  'profile.modal.phone': 'Phone',
  'profile.modal.email': 'Email',
  'profile.message.avatarSizeLimit': 'Image size cannot exceed 2MB',
  'profile.message.avatarUploadSuccess': 'Avatar uploaded successfully',
  'profile.message.saveSuccess': 'Saved successfully',
  'profile.message.saveFailed': 'Save failed',
  'profile.message.uploadAvatarFailed': 'Failed to upload avatar',
  'profile.message.operationFailed': 'Operation failed',
  // Achievement System Internationalization
  'achievement.category.all': 'All',
  'achievement.category.basic': 'Basic',
  'achievement.category.creation': 'Creation',
  'achievement.category.payment': 'Payment',
  'achievement.category.membership': 'Membership',
  'achievement.category.level': 'Level',
  'achievement.category.social': 'Social',
  'achievement.category.works': 'Works',
  'achievement.level.current': 'Current Level: {level}',
  'achievement.stats.unlocked': 'Unlocked',
  'achievement.stats.locked': 'Locked',
  'achievement.stats.progress': 'Progress',
  'achievement.stats.exp': 'Current EXP',
  // Recharge Agreement Internationalization
  'rechargeAgreement.back': 'Back',
  'rechargeAgreement.title': 'Recharge Service Agreement',
  'rechargeAgreement.lastUpdated': 'Last updated: ',
  'rechargeAgreement.goRecharge': 'Go to Recharge',
  'rechargeAgreement.section1.title': 'I. Agreement Scope',
  'rechargeAgreement.section1.content1': 'This agreement is a legal agreement between you and the platform regarding recharge services. Before using the recharge service, please read all contents of this agreement carefully. If you do not agree with any content of this agreement, or cannot accurately understand the meaning of relevant terms, please do not proceed with recharge operations.',
  'rechargeAgreement.section1.content2': 'When you click "Agree" or proceed with recharge operations, it means you have fully read, understood and agreed to accept all contents of this agreement.',
  'rechargeAgreement.section2.title': 'II. Recharge Instructions',
  'rechargeAgreement.section2.subtitle1': '2.1 Recharge Methods',
  'rechargeAgreement.section2.content1': 'The platform supports the following recharge methods:',
  'rechargeAgreement.section2.method1': 'Alipay',
  'rechargeAgreement.section2.method2': 'WeChat Pay',
  'rechargeAgreement.section2.method3': 'Bank Card (UnionPay, Visa, MasterCard)',
  'rechargeAgreement.section2.method4': 'USDT Cryptocurrency (ERC20/TRC20)',
  'rechargeAgreement.section2.subtitle2': '2.2 Recharge Currency',
  'rechargeAgreement.section2.content2': 'The platform supports the following currencies: CNY, USD, USDT. Exchange rate conversion may exist between different currencies, and the specific exchange rate is subject to the real-time exchange rate at the time of recharge.',
  'rechargeAgreement.section2.subtitle3': '2.3 Recharge Limits',
  'rechargeAgreement.section2.limit1': 'Minimum single recharge: 1 yuan (or equivalent in other currencies)',
  'rechargeAgreement.section2.limit2': 'Maximum single recharge: 50,000 yuan (or equivalent in other currencies)',
  'rechargeAgreement.section2.limit3': 'Daily cumulative recharge limit: 100,000 yuan (or equivalent in other currencies)',
  'rechargeAgreement.section2.note': 'Note: Recharge limits may vary depending on payment methods, account levels and other factors. Please refer to the recharge page for details.',
  'rechargeAgreement.section3.title': 'III. Recharge Arrival',
  'rechargeAgreement.section3.subtitle1': '3.1 Arrival Time',
  'rechargeAgreement.section3.time1': 'Alipay, WeChat Pay: Real-time arrival',
  'rechargeAgreement.section3.time2': 'Bank Card: 1-3 business days',
  'rechargeAgreement.section3.time3': 'USDT: According to blockchain confirmation time, usually 10-30 minutes',
  'rechargeAgreement.section3.subtitle2': '3.2 Exception Handling',
  'rechargeAgreement.section3.content1': 'If the recharge does not arrive in time, please keep the payment voucher and contact customer service in time. The platform will handle your recharge issue as soon as possible after verification.',
  'rechargeAgreement.section4.title': 'IV. Refund Policy',
  'rechargeAgreement.section4.important': 'Important: After successful recharge, account balance does not support direct refund. Balance can only be used for platform service consumption.',
  'rechargeAgreement.section4.subtitle1': '4.1 Refund Conditions',
  'rechargeAgreement.section4.content1': 'You can apply for a refund in the following cases:',
  'rechargeAgreement.section4.refund1': 'Duplicate recharge due to platform system failure',
  'rechargeAgreement.section4.refund2': 'Service unavailable due to platform reasons, and account balance has not been consumed',
  'rechargeAgreement.section4.refund3': 'Other special circumstances approved by the platform after review',
  'rechargeAgreement.section4.subtitle2': '4.2 Refund Process',
  'rechargeAgreement.section4.process1': 'Submit refund application and explain the reason',
  'rechargeAgreement.section4.process2': 'Platform review (usually 3-7 business days)',
  'rechargeAgreement.section4.process3': 'After approval, the refund will be returned to your payment account',
  'rechargeAgreement.section5.title': 'V. Account Security',
  'rechargeAgreement.section5.content1': 'You are responsible for properly keeping your account information and password. The platform is not responsible for losses caused by account theft or password leakage due to your own reasons.',
  'rechargeAgreement.section5.content2': 'If you find any account abnormality, please contact customer service immediately and change your password. The platform will assist you in handling related issues.',
  'rechargeAgreement.section6.title': 'VI. Disclaimer',
  'rechargeAgreement.section6.disclaimer1': 'The platform is not responsible for service interruptions caused by force majeure (such as natural disasters, wars, government actions, etc.)',
  'rechargeAgreement.section6.disclaimer2': 'For recharge issues caused by third-party payment platform failures, the platform will assist in handling but does not bear direct responsibility',
  'rechargeAgreement.section6.disclaimer3': 'Losses caused by users violating this agreement or relevant laws and regulations shall be borne by users themselves',
  'rechargeAgreement.section7.title': 'VII. Agreement Modification',
  'rechargeAgreement.section7.content1': 'The platform has the right to modify this agreement according to business development needs. After the agreement is modified, it will be announced in a prominent position on the platform. If you continue to use the recharge service, it is deemed that you accept the modified agreement.',
  'rechargeAgreement.section8.title': 'VIII. Contact Information',
  'rechargeAgreement.section8.content1': 'If you have any questions about this agreement, or need to apply for a refund or handle recharge issues, please contact us through the following methods:',
  'rechargeAgreement.section8.contact1': 'Customer Service Email: support@example.com',
  'rechargeAgreement.section8.contact2': 'Online Customer Service: Weekdays 9:00-18:00',
  'rechargeAgreement.section8.contact3': 'Help Center: View FAQ',
  'privacyPreferences.title': 'Privacy Preferences',
  'privacyPreferences.description': 'Manage your privacy settings and control how we collect and use your data',
  'privacyPreferences.back': 'Back',
  'privacyPreferences.save': 'Save Settings',
  'privacyPreferences.saveSuccess': 'Privacy preferences saved successfully',
  'privacyPreferences.saveError': 'Failed to save, please try again later',
  'privacyPreferences.required': 'Required',
  'privacyPreferences.info': 'Your privacy preferences will be saved locally and automatically applied on your next visit. Log in to sync settings to the cloud.',
  'privacyPreferences.info.loggedIn': 'Your privacy preferences will be saved to your account and synced across all devices. You can return to this page to modify these settings at any time.',
  'cookieBanner.message': 'We use cookies and local storage for login, theme and essential features. By continuing you agree to our use as described in our Privacy Policy.',
  'cookieBanner.acceptAll': 'Accept All',
  'cookieBanner.essentialOnly': 'Essential Only',
  'cookieBanner.settings': 'Preferences',
  'privacyPreferences.cookies.title': 'Cookie Preferences',
  'privacyPreferences.cookies.description': 'Cookies help us provide a better service experience. You can choose to accept or reject certain types of cookies.',
  'privacyPreferences.cookies.essential': 'Essential Cookies',
  'privacyPreferences.cookies.essential.desc': 'These cookies are necessary for the website to function properly and cannot be disabled. They are usually used for security, login, and basic functionality.',
  'privacyPreferences.cookies.functional': 'Functional Cookies',
  'privacyPreferences.cookies.functional.desc': 'These cookies allow the website to remember your choices and provide enhanced functionality and personalized experience.',
  'privacyPreferences.cookies.analytics': 'Analytics Cookies',
  'privacyPreferences.cookies.analytics.desc': 'These cookies help us understand how visitors use the website so we can improve our services.',
  'privacyPreferences.cookies.marketing': 'Marketing Cookies',
  'privacyPreferences.cookies.marketing.desc': 'These cookies are used to track your browsing activity to show you relevant ads and content.',
  'privacyPreferences.data.title': 'Data Collection Preferences',
  'privacyPreferences.data.description': 'Control how we collect and use your data to improve service experience.',
  'privacyPreferences.data.collection': 'Data Collection',
  'privacyPreferences.data.collection.desc': 'Allow us to collect necessary usage data to provide and improve services.',
  'privacyPreferences.data.analytics': 'Data Analytics',
  'privacyPreferences.data.analytics.desc': 'Allow us to analyze your usage patterns to optimize service performance and user experience.',
  'privacyPreferences.data.personalization': 'Personalization',
  'privacyPreferences.data.personalization.desc': 'Allow us to provide personalized content and recommendations based on your preferences and usage habits.',
  'privacyPreferences.marketing.title': 'Marketing Preferences',
  'privacyPreferences.marketing.description': 'Choose the types of marketing communications you wish to receive.',
  'privacyPreferences.marketing.emails': 'Marketing Emails',
  'privacyPreferences.marketing.emails.desc': 'Receive email notifications about product updates, promotions, and special offers.',
  'privacyPreferences.marketing.sms': 'Marketing SMS',
  'privacyPreferences.marketing.sms.desc': 'Receive SMS notifications about important updates and promotions.',
  'privacyPreferences.marketing.push': 'Push Notifications',
  'privacyPreferences.marketing.push.desc': 'Receive browser push notifications including product updates and important messages.',
  'privacyPreferences.thirdParty.title': 'Third-Party Data Sharing',
  'privacyPreferences.thirdParty.description': 'Control whether to allow sharing your data with third-party service providers.',
  'privacyPreferences.thirdParty.sharing': 'Third-Party Data Sharing',
  'privacyPreferences.thirdParty.sharing.desc': 'Allow us to share anonymized usage data with trusted third-party service providers to improve services.',
  'works.title': 'My Works',
  'works.description': 'Manage and view all your generated works',
  'works.refresh': 'Refresh',
  'works.stats.total': 'Total Works',
  'works.stats.images': 'Images',
  'works.stats.videos': 'Videos',
  'works.stats.audios': 'Audios',
  'works.stats.favorites': 'Favorites',
  'works.search.placeholder': 'Search works...',
  'works.filter.all': 'All Types',
  'works.filter.image': 'Images',
  'works.filter.video': 'Videos',
  'works.filter.audio': 'Audios',
  'works.date.start': 'Start Date',
  'works.date.end': 'End Date',
  'works.sort.date': 'By Date',
  'works.sort.name': 'By Name',
  'works.sort.size': 'By Size',
  'works.sort.asc': 'Ascending',
  'works.sort.desc': 'Descending',
  'works.view.grid': 'Grid',
  'works.view.list': 'List',
  'works.type.video': 'Video',
  'works.type.image': 'Image',
  'works.type.audio': 'Audio',
  'works.preview': 'Preview',
  'works.download': 'Download',
  'works.share': 'Share',
  'works.delete': 'Delete',
  'works.deleteConfirm': 'Are you sure you want to delete this work?',
  'works.loadError': 'Failed to load works, please try again later',
  'works.favoriteUpdated': 'Favorite status updated',
  'works.favoriteError': 'Failed to update favorite',
  'works.downloading': 'Downloading...',
  'works.sharing': 'Generating share link...',
  'works.deleted': 'Work deleted',
  'works.deleteError': 'Failed to delete, please try again later',
  'works.empty.title': 'No Works',
  'works.empty.description': 'Start creating your first work!',
  'works.empty.action': 'Create Now',
  'works.pagination.total': 'Total {total} items, showing {start}-{end}',
  
  // Privacy Policy
  'privacyPolicy.title': 'Privacy Policy',
  'privacyPolicy.lastUpdated': 'Last Updated: {date}',
  'privacyPolicy.intro1': 'This Privacy Policy describes how AIMATEX platform (hereinafter referred to as "we" or "this platform") collects, uses, stores, and protects your personal information when you use our services, as well as your privacy rights. We take your privacy protection very seriously. Please read this Privacy Policy carefully.',
  'privacyPolicy.intro2': 'By using our services, you agree to this Privacy Policy. If you do not agree with any part of this Privacy Policy, please do not use our services.',
  'privacyPolicy.section1.title': 'I. Information We Collect',
  'privacyPolicy.section1.1.title': '1.1 Information You Provide',
  'privacyPolicy.section1.1.intro': 'When using this service, you may need to provide the following information:',
  'privacyPolicy.section1.1.item1.label': 'Account Information',
  'privacyPolicy.section1.1.item1.desc': 'Username, email address, password, phone number, etc.',
  'privacyPolicy.section1.1.item2.label': 'Profile Information',
  'privacyPolicy.section1.1.item2.desc': 'Avatar, nickname, bio, etc. (optional)',
  'privacyPolicy.section1.1.item3.label': 'Payment Information',
  'privacyPolicy.section1.1.item3.desc': 'Payment methods, billing address, etc. (for processing payments)',
  'privacyPolicy.section1.1.item4.label': 'Generated Content',
  'privacyPolicy.section1.1.item4.desc': 'Text prompts, reference images, generated videos, music, images, 3D models, etc. that you upload',
  'privacyPolicy.section1.2.title': '1.2 Automatically Collected Information',
  'privacyPolicy.section1.2.intro': 'When you use this service, we may automatically collect the following information:',
  'privacyPolicy.section1.2.item1.label': 'Device Information',
  'privacyPolicy.section1.2.item1.desc': 'Device type, operating system, browser type and version, device identifiers, etc.',
  'privacyPolicy.section1.2.item2.label': 'Usage Data',
  'privacyPolicy.section1.2.item2.desc': 'Access time, pages visited, features used, operation records, etc.',
  'privacyPolicy.section1.2.item3.label': 'Network Information',
  'privacyPolicy.section1.2.item3.desc': 'IP address, network type, network operator, etc.',
  'privacyPolicy.section1.2.item4.label': 'Log Information',
  'privacyPolicy.section1.2.item4.desc': 'Error logs, performance data, etc.',
  'privacyPolicy.section1.3.title': '1.3 Cookies and Similar Technologies',
  'privacyPolicy.section1.3.intro': 'We use cookies and similar technologies to:',
  'privacyPolicy.section1.3.item1': 'Maintain your login status',
  'privacyPolicy.section1.3.item2': 'Remember your preferences (such as language, theme, etc.)',
  'privacyPolicy.section1.3.item3': 'Analyze service usage to improve service quality',
  'privacyPolicy.section1.3.item4': 'Provide personalized experience',
  'privacyPolicy.section1.3.note': 'You can refuse cookies through browser settings, but this may affect the use of some features.',
  'privacyPolicy.section2.title': 'II. Purpose of Information Use',
  'privacyPolicy.section2.intro': 'We collect and use your information for the following purposes:',
  'privacyPolicy.section2.item1.label': 'Provide Services',
  'privacyPolicy.section2.item1.desc': 'Process your content generation requests (including videos, music, images, 3D models, etc.), manage your account and works, etc.',
  'privacyPolicy.section2.item2.label': 'Improve Services',
  'privacyPolicy.section2.item2.desc': 'Analyze usage, optimize service performance and user experience',
  'privacyPolicy.section2.item3.label': 'Account Management',
  'privacyPolicy.section2.item3.desc': 'Verify identity, process payments, send notifications, etc.',
  'privacyPolicy.section2.item4.label': 'Security',
  'privacyPolicy.section2.item4.desc': 'Detect and prevent fraud, abuse, security threats, etc.',
  'privacyPolicy.section2.item5.label': 'Customer Support',
  'privacyPolicy.section2.item5.desc': 'Respond to your inquiries, handle complaints and feedback, etc.',
  'privacyPolicy.section2.item6.label': 'Legal Compliance',
  'privacyPolicy.section2.item6.desc': 'Comply with legal requirements, cooperate with law enforcement investigations, etc.',
  'privacyPolicy.section3.title': 'III. Information Sharing and Disclosure',
  'privacyPolicy.section3.1.title': '3.1 We Do Not Sell Your Personal Information',
  'privacyPolicy.section3.1.content': 'We do not sell, rent, or otherwise trade your personal information to third parties.',
  'privacyPolicy.section3.2.title': '3.2 Service Providers',
  'privacyPolicy.section3.2.intro': 'We may share information with the following types of service providers:',
  'privacyPolicy.section3.2.item1.label': 'Cloud Service Providers',
  'privacyPolicy.section3.2.item1.desc': 'For data storage and processing',
  'privacyPolicy.section3.2.item2.label': 'Payment Service Providers',
  'privacyPolicy.section3.2.item2.desc': 'For processing payment transactions',
  'privacyPolicy.section3.2.item3.label': 'Analytics Service Providers',
  'privacyPolicy.section3.2.item3.desc': 'For analyzing service usage',
  'privacyPolicy.section3.2.item4.label': 'Customer Support Service Providers',
  'privacyPolicy.section3.2.item4.desc': 'For providing customer support',
  'privacyPolicy.section3.2.note': 'These service providers can only use the information to provide services to us and not for other purposes.',
  'privacyPolicy.section3.3.title': '3.3 Legal Requirements',
  'privacyPolicy.section3.3.intro': 'We may disclose your information in the following circumstances:',
  'privacyPolicy.section3.3.item1': 'Comply with laws, regulations, court orders, or government requirements',
  'privacyPolicy.section3.3.item2': 'Protect our rights, property, or safety',
  'privacyPolicy.section3.3.item3': 'Prevent or investigate possible illegal activities',
  'privacyPolicy.section3.3.item4': 'Protect the safety of users or the public',
  'privacyPolicy.section3.4.title': '3.4 Business Transfer',
  'privacyPolicy.section3.4.content': 'If a merger, acquisition, or asset transfer occurs, your information may be transferred. We will notify you before the transfer.',
  'privacyPolicy.section4.title': 'IV. Information Storage and Security',
  'privacyPolicy.section4.1.title': '4.1 Storage Location',
  'privacyPolicy.section4.1.content': 'Your information may be stored on servers located within or outside the People\'s Republic of China. We will take appropriate measures to ensure the security of the information.',
  'privacyPolicy.section4.2.title': '4.2 Storage Period',
  'privacyPolicy.section4.2.intro': 'We only retain your information for the necessary period:',
  'privacyPolicy.section4.2.item1': 'Account information: During your account\'s existence and for a period after cancellation',
  'privacyPolicy.section4.2.item2': 'Generated content: Retained according to your settings or legal requirements',
  'privacyPolicy.section4.2.item3': 'Usage data: Usually retained for a shorter period for analysis and service improvement',
  'privacyPolicy.section4.3.title': '4.3 Security Measures',
  'privacyPolicy.section4.3.intro': 'We take the following security measures to protect your information:',
  'privacyPolicy.section4.3.item1': 'Encrypted transmission and storage',
  'privacyPolicy.section4.3.item2': 'Access control and authentication',
  'privacyPolicy.section4.3.item3': 'Regular security audits and vulnerability scans',
  'privacyPolicy.section4.3.item4': 'Employee training and confidentiality agreements',
  'privacyPolicy.section4.3.note': 'Please note that no security measure is 100% secure. We cannot guarantee absolute security of information.',
  'privacyPolicy.section5.title': 'V. Your Rights',
  'privacyPolicy.section5.intro': 'According to applicable laws and regulations, you have the following rights:',
  'privacyPolicy.section5.item1.label': 'Right of Access',
  'privacyPolicy.section5.item1.desc': 'View your personal information held by us',
  'privacyPolicy.section5.item2.label': 'Right of Rectification',
  'privacyPolicy.section5.item2.desc': 'Correct inaccurate or incomplete information',
  'privacyPolicy.section5.item3.label': 'Right of Erasure',
  'privacyPolicy.section5.item3.desc': 'Request deletion of your personal information (except where required by law)',
  'privacyPolicy.section5.item4.label': 'Right to Withdraw Consent',
  'privacyPolicy.section5.item4.desc': 'Withdraw your consent to information processing',
  'privacyPolicy.section5.item5.label': 'Right to Data Portability',
  'privacyPolicy.section5.item5.desc': 'Obtain a copy of your personal information',
  'privacyPolicy.section5.item6.label': 'Right to Object',
  'privacyPolicy.section5.item6.desc': 'Object to certain information processing activities',
  'privacyPolicy.section5.note': 'To exercise the above rights, please contact us through the contact information at the end of this Privacy Policy.',
  'privacyPolicy.section6.title': 'VI. Minor Protection',
  'privacyPolicy.section6.content1': 'This service is primarily intended for users over 18 years of age. If you are under 18, please use this service with the consent and guidance of your guardian.',
  'privacyPolicy.section6.content2': 'If we discover that we have collected personal information from users under 18 without guardian consent, we will delete the relevant information as soon as possible.',
  'privacyPolicy.section7.title': 'VII. Third-Party Links',
  'privacyPolicy.section7.content': 'This service may contain links to third-party websites. We are not responsible for the privacy practices of these third-party websites. When visiting these websites, please review their privacy policies.',
  'privacyPolicy.section8.title': 'VIII. Privacy Policy Changes',
  'privacyPolicy.section8.content1': 'We may update this Privacy Policy from time to time. Significant changes will be notified to you at least 30 days before they take effect. Continued use of the service indicates your acceptance of the updated Privacy Policy.',
  'privacyPolicy.section8.content2': 'We will update the "Last Updated" date at the top of this page and notify you of important changes via email or in-app notifications.',
  'privacyPolicy.section9.title': 'IX. Contact Us',
  'privacyPolicy.section9.intro': 'If you have any questions, comments, or complaints about this Privacy Policy, please contact us through the following methods:',
  'privacyPolicy.section9.email': 'Email: {email}',
  'privacyPolicy.section9.hours': 'Customer Service Hours: Weekdays 9:00-18:00',
  'privacyPolicy.section9.response': 'We will respond to your request within a reasonable time.',
  
  // Terms of Service
  'termsOfService.title': 'Terms of Service',
  'termsOfService.lastUpdated': 'Last Updated: {date}',
  'termsOfService.intro': 'Before using our services, please read these Terms of Service carefully. By accessing or using the AIMATEX platform (hereinafter referred to as "this platform" or "service"), you agree to be bound by these Terms of Service. If you do not agree with any part of these Terms of Service, please do not use our services.',
  'termsOfService.section1.title': 'I. Definitions and Interpretation',
  'termsOfService.section1.1.title': '1.1 Definitions',
  'termsOfService.section1.1.intro': 'In these Terms of Service, unless the context otherwise requires, the following terms have the following meanings:',
  'termsOfService.section1.1.item1.label': '"Platform" or "This Platform"',
  'termsOfService.section1.1.item1.desc': 'Refers to the AIMATEX comprehensive AI creation platform, including but not limited to websites, mobile applications, and related services.',
  'termsOfService.section1.1.item2.label': '"We", "Us", "Company"',
  'termsOfService.section1.1.item2.desc': 'Refers to the operator of the AIMATEX platform, namely ProTX Team.',
  'termsOfService.section1.1.item3.label': '"You", "User"',
  'termsOfService.section1.1.item3.desc': 'Refers to any individual, company, or other legal entity that accesses or uses this service.',
  'termsOfService.section1.1.item4.label': '"Service"',
  'termsOfService.section1.1.item4.desc': 'Refers to all functions and services provided by this platform, including but not limited to AI video, music, image, 3D model generation and other content creation, model selection, work management, user account management, etc.',
  'termsOfService.section1.1.item5.label': '"Content"',
  'termsOfService.section1.1.item5.desc': 'Refers to any text, images, videos, audio, and other materials uploaded, generated, created, or shared by users through this platform.',
  'termsOfService.section1.1.item6.label': '"Generated Content"',
  'termsOfService.section1.1.item6.desc': 'Refers to videos, music, images, 3D models and other works generated by users using AI models on this platform.',
  'termsOfService.section1.1.item7.label': '"Account"',
  'termsOfService.section1.1.item7.desc': 'Refers to the user account registered by users on this platform.',
  'termsOfService.section2.title': 'II. Service Description',
  'termsOfService.section2.1.title': '2.1 Service Content',
  'termsOfService.section2.1.intro': 'This platform provides comprehensive AI content generation services, including but not limited to:',
  'termsOfService.section2.1.item1': 'Text-to-Media (videos, music, images, 3D models, etc.)',
  'termsOfService.section2.1.item2': 'Image-to-Media (videos, 3D models, etc.)',
  'termsOfService.section2.1.item3': 'Management and display of various generated works',
  'termsOfService.section2.1.item4': 'Model selection and management',
  'termsOfService.section2.1.item5': 'User accounts and personal center',
  'termsOfService.section2.1.item6': 'Subscription and payment services',
  'termsOfService.section2.2.title': '2.2 Service Changes',
  'termsOfService.section2.2.content': 'We reserve the right to modify, suspend, or terminate part or all of the services at any time without prior notice. We are not responsible for any losses caused by service changes.',
  'termsOfService.section3.title': 'III. User Accounts',
  'termsOfService.section3.1.title': '3.1 Account Registration',
  'termsOfService.section3.1.intro': 'Using this service requires account registration. When registering, you agree to:',
  'termsOfService.section3.1.item1': 'Provide true, accurate, and complete registration information',
  'termsOfService.section3.1.item2': 'Update registration information in a timely manner to keep it true, accurate, and complete',
  'termsOfService.section3.1.item3': 'Be responsible for all activities under your account',
  'termsOfService.section3.1.item4': 'Keep your account password secure and not transfer, sell, or lend your account to others',
  'termsOfService.section3.2.title': '3.2 Age Restriction',
  'termsOfService.section3.2.content': 'You must be at least 18 years old to use this service. If you are under 18, please use this service with the consent and guidance of your guardian.',
  'termsOfService.section3.3.title': '3.3 Account Security',
  'termsOfService.section3.3.content': 'You are responsible for maintaining the security of your account. If you discover that your account has been compromised or there is a security vulnerability, please notify us immediately. We are not responsible for losses caused by your failure to properly protect your account information.',
  'termsOfService.section4.title': 'IV. Usage Guidelines',
  'termsOfService.section4.1.title': '4.1 Prohibited Activities',
  'termsOfService.section4.1.intro': 'When using this service, you must not:',
  'termsOfService.section4.1.item1': 'Generate, upload, or share any illegal, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, privacy-invading, or intellectual property-infringing content',
  'termsOfService.section4.1.item2': 'Generate or disseminate any false information, misleading content, or malicious content',
  'termsOfService.section4.1.item3': 'Use this service for any commercial fraud, money laundering, or other illegal activities',
  'termsOfService.section4.1.item4': 'Interfere with or disrupt the normal operation of this platform, including but not limited to using automated tools, crawlers, viruses, etc.',
  'termsOfService.section4.1.item5': 'Unauthorized access to any systems, data, or accounts of this platform',
  'termsOfService.section4.1.item6': 'Copy, modify, distribute, sell, or rent any part of this platform',
  'termsOfService.section4.1.item7': 'Reverse engineer, decompile, or disassemble any software of this platform',
  'termsOfService.section4.2.title': '4.2 Content Responsibility',
  'termsOfService.section4.2.content': 'You are fully responsible for all content generated, uploaded, or shared through this platform. We do not pre-review user-generated content but reserve the right to delete violating content at any time.',
  'termsOfService.section5.title': 'V. Intellectual Property',
  'termsOfService.section5.1.title': '5.1 Platform Intellectual Property',
  'termsOfService.section5.1.content': 'All intellectual property of this platform, including but not limited to trademarks, patents, copyrights, trade secrets, etc., belongs to us or relevant rights holders. You may not use them without authorization.',
  'termsOfService.section5.2.title': '5.2 User-Generated Content',
  'termsOfService.section5.2.content': 'The intellectual property of content you generate through this platform belongs to you. However, you grant us a non-exclusive, worldwide, free, and sublicensable right to use, display, and distribute your content for providing and improving services.',
  'termsOfService.section5.3.title': '5.3 AI Models',
  'termsOfService.section5.3.content': 'The intellectual property of AI models (including Sora models) used by this platform belongs to their developers. You may not copy, modify, or distribute these models.',
  'termsOfService.section6.title': 'VI. Paid Services',
  'termsOfService.section6.1.title': '6.1 Payment Models',
  'termsOfService.section6.1.content': 'This platform offers subscription and pay-per-use payment models. Specific prices and billing methods are subject to platform announcements.',
  'termsOfService.section6.2.title': '6.2 Payment',
  'termsOfService.section6.2.content': 'You agree to pay service fees according to the prices announced by the platform. All fees are priced in RMB or other currencies supported by the platform. After successful payment, fees are non-refundable unless otherwise required by law or we have made other commitments.',
  'termsOfService.section6.3.title': '6.3 Refund Policy',
  'termsOfService.section6.3.content': 'Unless otherwise required by law or we have made other commitments, paid fees are non-refundable. If the service cannot be used normally due to platform reasons, we will provide refunds or compensation based on the actual situation.',
  'termsOfService.section7.title': 'VII. Service Availability',
  'termsOfService.section7.1.title': '7.1 Service Interruption',
  'termsOfService.section7.1.intro': 'We are not responsible for service interruptions caused by the following reasons:',
  'termsOfService.section7.1.item1': 'System maintenance, upgrades, or failures',
  'termsOfService.section7.1.item2': 'Force majeure factors (such as natural disasters, wars, strikes, etc.)',
  'termsOfService.section7.1.item3': 'Issues with third-party service providers',
  'termsOfService.section7.1.item4': 'Network failures or user device problems',
  'termsOfService.section7.2.title': '7.2 Service Guarantee',
  'termsOfService.section7.2.content': 'We strive to ensure service stability and availability but do not guarantee that the service will not be interrupted, error-free, or completely secure. The service is provided on an "as is" and "as available" basis without any express or implied warranties.',
  'termsOfService.section8.title': 'VIII. Privacy Protection',
  'termsOfService.section8.content': 'We value your privacy protection. For information on how we collect, use, and protect your personal information, please refer to our Privacy Policy. Using this service indicates your agreement to our Privacy Policy.',
  'termsOfService.section9.title': 'IX. Limitation of Liability',
  'termsOfService.section9.1.title': '9.1 Scope of Liability',
  'termsOfService.section9.1.intro': 'To the maximum extent permitted by law, we are not liable for any direct, indirect, incidental, special, or consequential damages arising from the use or inability to use this service, including but not limited to:',
  'termsOfService.section9.1.item1': 'Profit loss, data loss, or other economic losses',
  'termsOfService.section9.1.item2': 'Business interruption',
  'termsOfService.section9.1.item3': 'Personal injury or property damage',
  'termsOfService.section9.1.item4': 'Privacy breach',
  'termsOfService.section9.2.title': '9.2 Liability Cap',
  'termsOfService.section9.2.content': 'Our total liability does not exceed the total amount you actually paid for this service in the past 12 months, or $100 (whichever is higher).',
  'termsOfService.section10.title': 'X. Service Termination',
  'termsOfService.section10.1.title': '10.1 User Termination',
  'termsOfService.section10.1.content': 'You may stop using this service and cancel your account at any time.',
  'termsOfService.section10.2.title': '10.2 Platform Termination',
  'termsOfService.section10.2.intro': 'We have the right to immediately terminate or suspend your account and service under the following circumstances:',
  'termsOfService.section10.2.item1': 'You violate these Terms of Service',
  'termsOfService.section10.2.item2': 'You engage in any illegal activities',
  'termsOfService.section10.2.item3': 'Your account has been inactive for a long time',
  'termsOfService.section10.2.item4': 'Legal or regulatory requirements',
  'termsOfService.section10.2.note': 'After service termination, you will not be able to access your account and generated content unless otherwise required by law.',
  'termsOfService.section11.title': 'XI. Dispute Resolution',
  'termsOfService.section11.1.title': '11.1 Negotiation',
  'termsOfService.section11.1.content': 'If a dispute occurs, both parties should first resolve it through friendly negotiation.',
  'termsOfService.section11.2.title': '11.2 Applicable Law',
  'termsOfService.section11.2.content': 'These Terms of Service are governed by the laws of the People\'s Republic of China. If both parties cannot resolve the dispute through negotiation, it shall be submitted to a people\'s court with jurisdiction in our location.',
  'termsOfService.section12.title': 'XII. Other Terms',
  'termsOfService.section12.1.title': '12.1 Terms Modification',
  'termsOfService.section12.1.content': 'We reserve the right to modify these Terms of Service at any time. Significant modifications will be notified to you at least 30 days before they take effect. Continued use of the service indicates your acceptance of the modified terms.',
  'termsOfService.section12.2.title': '12.2 Severability',
  'termsOfService.section12.2.content': 'If any provision of these Terms of Service is deemed invalid or unenforceable, it does not affect the validity of other provisions.',
  'termsOfService.section12.3.title': '12.3 Complete Agreement',
  'termsOfService.section12.3.content': 'These Terms of Service constitute the complete agreement between you and us regarding the use of this service, replacing all previous oral or written agreements.',
  'termsOfService.section13.title': 'XIII. Contact Us',
  'termsOfService.section13.intro': 'If you have any questions about these Terms of Service, please contact us through the following methods:',
  'termsOfService.section13.email': 'Email: {email}',
  'termsOfService.section13.hours': 'Customer Service Hours: Weekdays 9:00-18:00',
  
  // Footer
  'footer.brand.description': 'Provides AI generation services.',
  'footer.joinUs': 'Join Us',
  'footer.product.title': 'Product',
  'footer.product.signup': 'Sign Up',
  'footer.product.login': 'Login',
  'footer.product.workspace': 'Workspace',
  'footer.product.works': 'My Works',
  'footer.product.community': 'Community',
  'footer.support.title': 'Support',
  'footer.support.help': 'Help Center',
  'footer.support.about': 'About Us',
  'footer.support.feedback': 'Feedback',
  'footer.support.contact': 'Contact Us',
  'footer.legal.title': 'Legal',
  'footer.legal.privacy': 'Privacy Policy',
  'footer.legal.terms': 'Terms of Service',
  'footer.legal.recharge': 'Recharge Agreement',
  'footer.resources.title': 'Resources',
  'footer.resources.invite': 'Invite Friends',
  'footer.resources.account': 'Account Management',
  'footer.resources.orders': 'Order Center',
  'footer.copyright': '© {year} {brand}. All rights reserved.',
  'footer.description': 'This platform provides AI generation services',
  'footer.openRobotX.title': 'Open Robot X',
  'footer.openRobotX.description': 'Global humanoid robotics database with specs comparison and industry insights',
  'footer.openRobotX.visit': 'Visit Open Robot X',
  'footer.ai2obj.title': 'ai2obj',
  'footer.ai2obj.description': 'AI-powered comprehensive generation platform for creating diverse digital content',
  'footer.aimatexMusic.title': 'AIMATEX-MUSIC',
  'footer.aimatexMusic.description': 'Personal cloud music: discover, playlists, Now Playing, and cloud library',
  'footer.aimatexNas.title': 'AIMATEX-NAS / Cloud',
  'footer.aimatexNas.description': 'Personal data warehouse & cloud drive — files, local share, AI-ready',
  
  // Pricing page
  'pricing.title': 'Choose the Plan That Works for You',
  'pricing.plan.basic.sub': 'Basic',
  'pricing.plan.pro.sub': 'Pro',
  'pricing.plan.team.sub': 'Team',
  'pricing.plan.popular': 'POPULAR',
  'pricing.plan.button.select': 'Select Plan',
  'pricing.plan.button.subscribe': 'Subscribe Now',
  'pricing.plan.basic.videoQuota': '5/month',
  'pricing.plan.basic.videoDuration': '6-10s',
  'pricing.plan.basic.videoQuality': '720P',
  'pricing.plan.pro.videoQuota': '30/month',
  'pricing.plan.pro.videoDuration': '10-15s',
  'pricing.plan.pro.videoQuality': '1080P',
  'pricing.plan.team.videoQuota': '100/month',
  'pricing.plan.team.videoDuration': '10-15s',
  'pricing.plan.team.videoQuality': '1080P/4K',
  'pricing.feature.videoQuota': 'Video Generation Quota',
  'pricing.feature.videoDuration': 'Video Duration',
  'pricing.feature.videoQuality': 'Video Quality',
  'pricing.feature.storyboard': 'Storyboard',
  'pricing.feature.workflow': 'Workflow',
  'pricing.feature.priorityQueue': 'Priority Queue',
  'pricing.feature.exclusiveChannel': 'Exclusive Channel',
  'pricing.feature.highestQuality': 'Highest Quality Mode',
  'pricing.feature.sdImage': 'SD Image Generation',
  'pricing.feature.unlimited': 'Unlimited',
  'pricing.feature.promptOptimization': 'Prompt Optimization',
  'pricing.feature.imageSize': 'Image Size',
  'pricing.feature.storage': 'Storage Space',
  'pricing.feature.commercialLicense': 'Commercial License',
  'pricing.feature.apiAccess': 'API Access',
  'pricing.then': 'then',
  'cta.title': 'Start Creating Your Videos',
  'cta.description': 'Sign up now and transform your creativity into stunning video works with AI technology',
  'cta.button': 'Start Creating for Free',
  'technology.coreArchitecture': 'CORE ARCHITECTURE',
  'technology.workflowEngine.title': 'Visual Workflow Engine',
  'technology.workflowEngine.description': 'Visual workflow support coming soon. Every node is a precise control over creativity.',
  'technology.node.checkpointLoader': 'Checkpoint Loader',
  'technology.node.clipTextPositive': 'CLIP Text (Positive)',
  'technology.node.clipTextNegative': 'CLIP Text (Negative)',
  'technology.node.ksamplerAdvanced': 'KSampler Advanced',
  'technology.node.vaeDecode': 'VAE Decode',
  'technology.node.previewImage': 'Preview Image',
  'technology.hud.systemResourceMonitor': 'System Resource Monitor',
  'technology.hud.gpuVram': 'GPU VRAM',
  'technology.terminal.console': 'console — zsh',
  'technology.button.runWorkflow': 'Run Workflow',
  'technology.button.running': 'Running...',
  'technology.log.systemInitialized': '> System initialized.',
  'technology.log.waitingForInput': '> Waiting for user input...',
  'technology.log.loadingCheckpoint': 'Loading SDXL Checkpoint (fp16)...',
  'technology.log.tokenizingPrompt': 'Tokenizing positive prompt...',
  'technology.log.ksamplerSteps': 'KSampler: 30/30 steps (Euler A)',
  'technology.log.generationComplete': 'Generation complete.',
  'technology.benchmark.title': 'Ultimate Performance Benchmark',
  'technology.benchmark.description': 'For this 0.5 second improvement, we rewrote 30% of the underlying operators.',
  'technology.benchmark.fps.title': 'Generation Speed (FPS)',
  'technology.benchmark.fps.subtitle': 'Comparison @ 1080p',
  'technology.benchmark.vram.title': 'VRAM Optimization',
  'technology.benchmark.vram.subtitle': 'Lower is better',
  'technology.benchmark.productX': 'ProductX',
  'technology.benchmark.others': 'Others',
  'technology.benchmark.standard': 'Standard',
  'technology.galaxy.openEcology': 'OPEN ECOLOGY',
  'technology.galaxy.title': 'Infinite Model Universe',
  'technology.galaxy.description': 'Support Civitai direct connection, thousands of models, one-click loading.',
  'technology.galaxy.autoSync': 'Auto-Sync',
  
  // Feedback Page
  'feedback.leftPanel.title.line1': 'We Listen to',
  'feedback.leftPanel.title.line2': 'Your Voice',
  'feedback.leftPanel.description': 'Your feedback is the driving force behind our product improvement. Whether you found a bug or have a brilliant new feature idea, please let us know.',
  'feedback.contact.helpDoc.title': 'Help Documentation',
  'feedback.contact.helpDoc.desc': 'Browse FAQs and user guides',
  'feedback.contact.email.title': 'Email Support',
  'feedback.contact.service.title': 'Online Support',
  'feedback.contact.service.hours': 'Weekdays 9:00 - 18:00',
  'feedback.type.suggestion.title': 'Feature Suggestion',
  'feedback.type.suggestion.desc': 'I have new ideas or improvement suggestions',
  'feedback.type.bug.title': 'Bug Report',
  'feedback.type.bug.desc': 'I encountered an error or exception',
  'feedback.type.question.title': 'Usage Inquiry',
  'feedback.type.question.desc': 'I don\'t understand how to use a feature',
  'feedback.type.other.title': 'Other',
  'feedback.type.other.desc': 'Other types of feedback',
  'feedback.form.type.label': 'Feedback Type',
  'feedback.form.title.label': 'Brief Summary',
  'feedback.form.title.placeholder': 'Describe your issue or suggestion in one sentence',
  'feedback.form.title.required': 'Please enter a title',
  'feedback.form.content.label': 'Detailed Description',
  'feedback.form.content.placeholder': 'Please describe the background, reproduction steps, or specific suggestions...',
  'feedback.form.content.required': 'Please enter detailed content',
  'feedback.form.attachment.label': 'Attachments (Optional)',
  'feedback.upload.dragText': 'Click or drag files here to upload',
  'feedback.upload.hint': 'Supports JPG, PNG, PDF and other formats, single file size not exceeding 5MB',
  'feedback.upload.sizeLimit': 'File size cannot exceed 5MB',
  'feedback.form.priority.label': 'Priority',
  'feedback.priority.low.label': 'Low',
  'feedback.priority.low.desc': 'Does not affect usage',
  'feedback.priority.medium.label': 'Medium',
  'feedback.priority.medium.desc': 'Affects user experience',
  'feedback.priority.high.label': 'High',
  'feedback.priority.high.desc': 'Seriously hinders usage',
  'feedback.form.contact.label': 'Contact Information (Optional)',
  'feedback.form.contact.placeholder': 'Email or phone number',
  'feedback.form.submit': 'Submit Feedback',
  'feedback.submit.error': 'Submission failed, please try again later',
  'feedback.success.title': 'Feedback Received!',
  'feedback.success.description': 'Thank you for your valuable feedback. Our product team will carefully read every piece of feedback. If it\'s a bug report, we may contact you through the provided contact information.',
  'feedback.success.back': 'Go Back',
  'feedback.success.another': 'Submit Another',
  // Invite Page
  'invite.partnerProgram': 'Partner Program',
  'invite.title.line1': 'Invite Friends',
  'invite.title.line2': 'Create Unlimited Value',
  'invite.reward.inviter': 'Earn {amount} cash reward for each friend you invite.',
  'invite.reward.invitee': 'Your friend gets {amount} welcome bonus upon registration.',
  'invite.step1.title': '1. Share Link',
  'invite.step1.desc': 'Share your exclusive link via social media',
  'invite.step2.title': '2. Friend Activates',
  'invite.step2.desc': 'Friend completes registration and verification',
  'invite.step3.title': '3. Withdraw Earnings',
  'invite.step3.desc': 'Earnings arrive instantly, withdraw to balance',
  'invite.exclusiveCode': 'YOUR EXCLUSIVE CODE',
  'invite.copyCode': 'Copy Code',
  'invite.viewQrcode': 'View QR Code',
  'invite.stats.totalInvites': 'Total Invites',
  'invite.stats.availableReward': 'Available Balance',
  'invite.stats.totalReward': 'Total Earnings',
  'invite.withdrawNow': 'Withdraw Now',
  'invite.history.title': 'Invite History',
  'invite.filter.all': 'All',
  'invite.filter.active': 'Active',
  'invite.filter.pending': 'Pending',
  'invite.status.credited': 'Credited',
  'invite.status.pending': 'Pending',
  'invite.history.empty': 'No records yet',
  'invite.withdraw.title': 'Withdraw Earnings',
  'invite.withdraw.cancel': 'Cancel',
  'invite.withdraw.confirm': 'Confirm Withdrawal',
  'invite.withdraw.amount': 'Withdrawal Amount',
  'invite.withdraw.note': '* The amount will be transferred directly to your account balance.',
  'invite.withdraw.enterAmount': 'Please enter withdrawal amount',
  'invite.withdraw.insufficientBalance': 'Insufficient balance',
  'invite.withdraw.success': 'Successfully withdrew ¥{amount} to balance',
  'invite.qrcode.title': 'Scan to Join',
  'invite.copyLink': 'Copy Link',
  'invite.copy.success': 'Copied successfully',
  // Home Hero Section
  'home.hero.badge': 'AI Assistant · Companion · Partner',
  'home.hero.title': 'AIMATEX',
  'home.hero.subtitle': 'Your Classmate, Soulmate, Teammate',
  'home.hero.lead': 'A gateway to our AI products. Discover music, creation, and intelligent tools from here.',
  'home.hero.description': 'AIMATEX is your AI assistant, learning partner, and creative companion. We provide comprehensive AI solutions, making AI your best partner in work, study, and creation. Whether it\'s classroom learning, creative collaboration, or team cooperation, AIMATEX is your trusted partner.',
  'home.hero.cta.signup': 'Get Started Free',
  'home.hero.cta.login': 'Sign In',
  'home.hero.cta.workspace': 'Go to Workspace',
  'home.hero.cta.explore': 'Explore products',
  'home.hero.scroll': 'Scroll',
  // Home Products Section
  'home.products.title': 'Our Products',
  'home.products.subtitle': 'Explore innovative AI products under AIMATEX, each product is your best partner in different scenarios',
  'home.products.seedance2.name': 'Seedance2',
  'home.products.seedance2.description': 'AI image-to-video creation partner, transforming static images into dynamic videos, bringing your creativity to life',
  'home.products.ai2obj.name': 'AI2Obj',
  'home.products.ai2obj.description': 'AI-powered 3D object generation and conversion platform, your 3D creation partner',
  'home.products.openrobotx.name': 'OpenRobotX',
  'home.products.openrobotx.description': 'Explore global humanoid robot companies, parameter comparisons and industry insights, your robotics research partner',
  'home.products.openclaw4j.name': 'OpenClaw4j',
  'home.products.openclaw4j.title': 'OpenClaw4j',
  'home.products.openclaw4j.description': 'Autonomous Agent platform — build and deploy intelligent agents with OpenForgeX.',
  'home.products.openclaw4j.cta': 'Try Agent',
  'home.products.aimatexMusic.name': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.title': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.description': 'Personal cloud music space — discover tracks, collaborative playlists, Now Playing, and your cloud library',
  'home.products.aimatexMusic.cta': 'Enter Music',
  'home.music.eyebrow': 'AIMATEX Suite',
  'home.music.title': 'AIMATEX-MUSIC',
  'home.music.subtitle': 'Your personal cloud music space — discover, collect, and listen together.',
  'home.music.feature.discover.title': 'Discover',
  'home.music.feature.discover.desc': 'Search and import tracks into your cloud library.',
  'home.music.feature.playlist.title': 'Playlists',
  'home.music.feature.playlist.desc': 'Create and share collaborative playlists.',
  'home.music.feature.nowPlaying.title': 'Now Playing',
  'home.music.feature.nowPlaying.desc': 'Synced listening, hearts, and play history.',
  'home.music.feature.cloud.title': 'Cloud Library',
  'home.music.feature.cloud.desc': 'High-quality audio stored securely in the cloud.',
  'home.music.cta': 'Open AIMATEX-MUSIC',

  'home.nas.eyebrow': 'AIMATEX Suite',
  'home.nas.title': 'AIMATEX-NAS / Cloud',
  'home.nas.subtitle': 'Your personal data warehouse and cloud drive — unify cloud and local data, then let AI become your data steward.',
  'home.nas.feature.cloud.title': 'Cloud Drive',
  'home.nas.feature.cloud.desc': 'Isolated personal space — upload anytime, access anywhere.',
  'home.nas.feature.local.title': 'Local Share',
  'home.nas.feature.local.desc': 'Connect home folders via the client; manage them from the web.',
  'home.nas.feature.warehouse.title': 'Data Warehouse',
  'home.nas.feature.warehouse.desc': 'Metadata, tags, and timelines turn scattered files into assets.',
  'home.nas.feature.ai.title': 'AI Data Expert',
  'home.nas.feature.ai.desc': 'Ask, organize, and search — within clear permission boundaries.',
  'home.nas.cta': 'Try AIMATEX-NAS',

  'home.showcase.seedance2.eyebrow': 'Image to Video',
  'home.showcase.seedance2.title': 'Seedance2',
  'home.showcase.seedance2.subtitle': 'Turn still frames into cinematic motion with a next-gen creation engine.',
  'home.showcase.seedance2.f1.title': 'Image to Video',
  'home.showcase.seedance2.f1.desc': 'Upload a photo — AI invents light and motion.',
  'home.showcase.seedance2.f2.title': 'Cinema Quality',
  'home.showcase.seedance2.f2.desc': 'High-res output with stable, crisp detail.',
  'home.showcase.seedance2.f3.title': 'Smart Prompts',
  'home.showcase.seedance2.f3.desc': 'AI polishes rough ideas into film-ready prompts.',
  'home.showcase.seedance2.f4.title': 'Style Switch',
  'home.showcase.seedance2.f4.desc': 'Cyberpunk, oil paint, anime — one click.',
  'home.showcase.seedance2.cta': 'Enter Seedance2',
  'home.showcase.ai2obj.eyebrow': '3D Generation',
  'home.showcase.ai2obj.title': 'AI2Obj',
  'home.showcase.ai2obj.subtitle': 'An AI generation platform that turns ideas into usable digital assets.',
  'home.showcase.ai2obj.f1.title': 'Multimodal',
  'home.showcase.ai2obj.f1.desc': 'From text and images to 3D and content assets.',
  'home.showcase.ai2obj.f2.title': 'Object Convert',
  'home.showcase.ai2obj.f2.desc': 'Structure understanding and format conversion.',
  'home.showcase.ai2obj.f3.title': 'Creator Workflow',
  'home.showcase.ai2obj.f3.desc': 'Pipelines built for product and content teams.',
  'home.showcase.ai2obj.f4.title': 'Cloud Delivery',
  'home.showcase.ai2obj.f4.desc': 'Preview, export, and collaborate in the cloud.',
  'home.showcase.ai2obj.cta': 'Visit AI2Obj',
  'home.showcase.openrobotx.eyebrow': 'Robotics Intel',
  'home.showcase.openrobotx.title': 'OpenRobotX',
  'home.showcase.openrobotx.subtitle': 'Global humanoid robot companies, specs, and industry insights in one place.',
  'home.showcase.openrobotx.f1.title': 'World Map',
  'home.showcase.openrobotx.f1.desc': 'Major humanoid vendors and products covered.',
  'home.showcase.openrobotx.f2.title': 'Spec Compare',
  'home.showcase.openrobotx.f2.desc': 'Clear side-by-side capability and positioning.',
  'home.showcase.openrobotx.f3.title': 'Industry News',
  'home.showcase.openrobotx.f3.desc': 'Funding, launches, and tech movements tracked.',
  'home.showcase.openrobotx.f4.title': 'Research Partner',
  'home.showcase.openrobotx.f4.desc': 'Structured intel for selection and research.',
  'home.showcase.openrobotx.cta': 'Explore OpenRobotX',
  'home.showcase.openclaw4j.eyebrow': 'Autonomous Agents',
  'home.showcase.openclaw4j.title': 'OpenClaw4j',
  'home.showcase.openclaw4j.subtitle': 'Build and deploy intelligent agents with OpenForgeX — make agents run for real.',
  'home.showcase.openclaw4j.f1.title': 'Agent Orchestration',
  'home.showcase.openclaw4j.f1.desc': 'Multi-step planning and execution.',
  'home.showcase.openclaw4j.f2.title': 'Tool Calling',
  'home.showcase.openclaw4j.f2.desc': 'Connect APIs and business systems.',
  'home.showcase.openclaw4j.f3.title': 'Observable Runs',
  'home.showcase.openclaw4j.f3.desc': 'Transparent traces for debug and iteration.',
  'home.showcase.openclaw4j.f4.title': 'One-click Deploy',
  'home.showcase.openclaw4j.f4.desc': 'From prototype to live service fast.',
  'home.showcase.openclaw4j.cta': 'Try Agent',

  'home.products.learnMore': 'Learn More',
  'home.hero.cta.demo': 'Watch film',
  // Home Features Section
  'home.features.title': 'All-in-One Creative Workshop.',
  'home.features.subtitle': 'More than just video generation, it\'s a comprehensive creative empowerment.',
  'home.features.aiPrompt.title': 'Can\'t Write Prompts? AI Writes for You',
  'home.features.aiPrompt.description': 'Completely out of ideas? Let AI write for you with one click. Just type a few words, AI automatically polishes them into cinematic descriptions, 10 seconds to output. Want to change style? Click again, instantly transform to cyberpunk/oil painting/anime.',
  'home.features.demo.userInput': 'a cat',
  'home.features.demo.aiResult': 'An elegant Persian cat with soft, fluffy white long fur and amber eyes, sitting on a sunlit windowsill. The background features a light blue sky and flowing white curtains. 4K ultra HD, cinematic lighting, depth of field, professional photography.',
  'home.features.demo.buttonText': 'AI Generate',
  'home.features.demo.buttonLoading': 'Generating',
  'home.features.demo.thinkingText': 'AI is creating✨',
  'home.features.quality.title': 'Cinematic Quality',
  'home.features.quality.description': 'Native support for 4K resolution output, every frame is delicately crafted.',
  'home.features.imageToVideo.title': 'Image to Video',
  'home.features.imageToVideo.description': 'Upload a static image, AI understands the lighting and physics in the scene, automatically generates subsequent dynamics, bringing photos to life.',
  'home.features.multimodal.title': 'Multimodal Ecosystem',
  'home.features.multimodal.description': 'Not only supports Stable Diffusion text-to-image, but also integrates Midjourney style transfer and ElevenLabs audio synthesis. Complete all creations in one workflow.',
  
  // Home Community Section
  'home.community.title': 'Explore AI Creative Communities',
  'home.community.subtitle': 'Join millions of creators, share your AI masterpieces, and get inspiration and feedback',
  'home.community.hot': 'Hot',
  'home.community.explore': 'Explore Community',
  'home.community.stats.works': 'Works',
  'home.community.stats.creators': 'Creators',
  'home.community.stats.views': 'Views',
  'home.community.image.title': 'AI Image Community',
  'home.community.image.description': 'Discover and share stunning AI-generated images, from photorealistic to artistic, from illustrations to photography',
  'home.community.video.title': 'AI Video Community',
  'home.community.video.description': 'Explore amazing AI-generated videos, learn creative techniques, and exchange experiences with global video creators',
  'home.community.music.title': 'AI Music Community',
  'home.community.music.description': 'Listen to beautiful melodies composed by AI, share your music works, and find like-minded music enthusiasts',
  'home.community.3d.title': 'AI 3D Model Community',
  'home.community.3d.description': 'Explore the world of AI-generated 3D models, from architecture to characters, from games to industrial design',
  'home.community.voice.title': 'AI Voice Community',
  'home.community.voice.description': 'Experience realistic AI voice synthesis, dubbing, audiobooks, voice cloning, and bring your creations to life',
  'home.community.text.title': 'AI Text Community',
  'home.community.text.description': 'Share excellent AI-created texts, novels, poems, scripts, copywriting, and inspire your literary creativity',

  // Prompt Market (market.* keys used by PromptMarketSection)
  'market.label': 'PROMPT MARKETPLACE',
  'market.h1': 'Unleash your',
  'market.h1.highlight': 'Unlimited Creativity.',
  'market.sub': 'The premium destination for AI prompts: image, video, and music. Verified recipes that work across OpenAI, Google, Midjourney, Runway, Kling, Luma, Suno, ElevenLabs, and more. Stop guessing, start creating.',
  'market.providers.title': 'Works with leading models & platforms',
  'market.card1.title': 'Instant Integration',
  'market.card1.desc': 'Skip the prompt engineering learning curve. Import battle-tested prompts directly into your workflow with one click.',
  'market.card2.title': 'Monetize Creativity',
  'market.card2.desc': 'Turn your best prompts into passive income. Join thousands of creators earning from their AI expertise.',
  'market.card3.title': 'Verified Quality',
  'market.card3.desc': 'Every listing is manually reviewed and tested. We guarantee consistent results across different models.',
  'market.card4.title': 'Explore the Lab',
  'market.card4.desc': 'Discover over 10,000+ assets generated by community.',
  'market.cta': 'Launch Prompt Market',
  'home.mediaTools.title': 'Media Tools',
  'home.mediaTools.subtitle': 'Use online, no installation required. Easily process your images, video and audio files.',
  'home.mediaTools.toolSuffix': ' Tool',
  'home.mediaTools.imageCompress.title': 'Image Compress',
  'home.mediaTools.imageCompress.description': 'Smart image compression while keeping quality. Batch processing supported.',
  'home.mediaTools.videoCompress.title': 'Video Compress',
  'home.mediaTools.videoCompress.description': 'Efficient video compression with custom resolution and bitrate. Multiple formats supported.',
  'home.mediaTools.audioCompress.title': 'Audio Compress',
  'home.mediaTools.audioCompress.description': 'Optimize audio file size while keeping clarity. Supports MP3, AAC and more.',

  // Legacy home.promptMarket (kept for any other refs)
  'home.promptMarket.title': 'Prompt Market · Your Ideas, Priced. Creativity, Unlimited.',
  'home.promptMarket.subtitle': 'Discover AI prompt recipes from creators worldwide, or list your own and earn. Buy and sell, all in one place.',
  'home.promptMarket.cta.headline': 'Stop writing prompts from scratch—create on the shoulders of giants',
  'home.promptMarket.cta.desc': 'Hot tags, bestsellers, latest listings—filter in one click. Save, buy, use in one click, seamlessly in your workflow.',
  'home.promptMarket.cta.button': 'Go to Prompt Market',
  'home.promptMarket.feature1.title': 'One-click top recipes',
  'home.promptMarket.feature1.desc': 'Explore creator-verified prompts for image, video & music—ready to use',
  'home.promptMarket.feature2.title': 'Monetize your creativity',
  'home.promptMarket.feature2.desc': 'List your prompt recipes and get discovered, saved, and paid',
  'home.promptMarket.feature3.title': 'Free & paid, side by side',
  'home.promptMarket.feature3.desc': 'Try free templates, buy premium recipes—transparent pricing',
  
  // Billing Page
  'billing.page.title': 'Billing Center',
  'billing.page.description': 'Manage your transactions and billing details',
  'billing.button.refresh': 'Refresh',
  'billing.button.recharge': 'Recharge',
  'billing.button.reset': 'Reset',
  'billing.button.apply': 'Apply Filters',
  
  // Balance Cards
  'billing.balance.cny': 'CNY Balance',
  'billing.balance.usdt': 'USDT Balance',
  'billing.balance.usd': 'USD Balance',
  'billing.balance.token': 'Token Balance',
  'billing.balance.frozen': 'Frozen',
  
  // Transaction Types
  'billing.type.frozen': 'Frozen',
  'billing.type.aiModelFee': 'AI Model Fee',
  'billing.type.recharge': 'Recharge',
  'billing.type.refund': 'Refund',
  'billing.type.reward': 'Reward',
  'billing.type.all': 'All Types',
  
  // Currencies
  'billing.coin.all': 'All Currencies',
  'billing.coin.usdt': 'USDT',
  'billing.coin.cny': 'CNY',
  'billing.coin.usd': 'USD',
  'billing.coin.token': 'TOKEN',
  
  // Table
  'billing.table.type': 'Type',
  'billing.table.coinType': 'Currency',
  'billing.table.time': 'Time',
  'billing.table.amount': 'Amount',
  'billing.table.remark': 'Remark',
  'billing.table.balance': 'Balance',
  'billing.table.empty': 'No records',
  
  // Filters
  'billing.filter.title': 'Filter Options',
  'billing.filter.button': 'Filter & Date',
  'billing.filter.changeType': 'Transaction Type',
  'billing.filter.coinType': 'Currency Type',
  'billing.filter.remark': 'Remark Search',
  'billing.filter.remarkPlaceholder': 'Enter remark keywords',
  'billing.filter.remarkSearch': 'Remark Search',
  'billing.filter.dateQuick': 'Quick Date',
  'billing.filter.dateCustom': 'Custom Date',
  'billing.filter.dateTo': 'to',
  'billing.filter.days7': 'Last 7 Days',
  'billing.filter.days30': 'Last 30 Days',
  'billing.filter.days90': 'Last 3 Months',
  
  // Placeholders
  'billing.placeholder.changeType': 'Change Type',
  'billing.placeholder.coinType': 'Currency',
  'billing.placeholder.remark': 'Remark Search',
  
  // Messages
  'billing.message.fetchBalanceError': 'Failed to fetch balance',
  'billing.message.fetchRecordsError': 'Failed to fetch billing records',
  'billing.message.tryAgain': 'Failed to fetch billing records, please try again later',
  
  // Recharge Page
  'recharge.page.title': 'Account Recharge',
  'recharge.page.backLink': 'Back to Billing',
  'recharge.balance.title': 'Account Balance',
  'recharge.balance.refresh': 'Refresh',
  
  // Recharge Sections
  'recharge.section.coinType': 'Currency Type',
  'recharge.section.paymentMethod': 'Payment Method',
  'recharge.section.amount': 'Recharge Amount',
  
  // Order Details
  'recharge.order.title': 'Order Details',
  'recharge.order.type': 'Recharge Type',
  'recharge.order.typeValue': 'Account Balance Recharge',
  'recharge.order.account': 'Account',
  'recharge.order.accountLoading': 'Loading...',
  'recharge.order.paymentMethod': 'Payment Method',
  'recharge.order.paymentMethodPlease': 'Please select',
  'recharge.order.total': 'Total Amount',
  
  // Buttons
  'recharge.button.pay': 'Pay Now',
  'recharge.button.customize': 'Custom Amount',
  
  // Placeholders
  'recharge.placeholder.customAmount': 'Enter custom amount',
  
  // Security
  'recharge.security.ssl': 'SSL encrypted transmission, secure payment',
  'recharge.security.agreement': 'By clicking Pay, you agree to',
  'recharge.security.agreementLink': 'Recharge Service Agreement',
  
  // Empty States
  'recharge.empty.noCurrency': 'No supported currencies',
  'recharge.empty.noPaymentMethod': 'No payment method available for {currency}',
  'recharge.empty.pleaseSelectCurrency': 'Please select currency first',
  'recharge.empty.pleaseSelectPayment': 'Please select payment method first',
  'recharge.empty.noProducts': 'No products available',
  'recharge.empty.noPresets': 'No preset amounts for {currency}',
  
  // Messages
  'recharge.message.invalidAmount': 'Please enter valid amount',
  'recharge.message.selectPaymentMethod': 'Please select payment method',
  'recharge.message.selectAmount': 'Please select recharge amount',
  'recharge.message.fetchBalanceError': 'Failed to fetch balance, please try again later',
  'recharge.message.fetchUserInfoError': 'Failed to fetch user info',
  'recharge.message.fetchCurrenciesError': 'Failed to fetch currencies, please try again later',
  'recharge.message.fetchPaymentMethodsError': 'Failed to fetch payment methods, please try again later',
  'recharge.message.fetchCreemProductsError': 'Failed to fetch Creem products, please try again later',
  'recharge.message.fetchCreemProductsWarning': 'Failed to fetch Creem products',
  'recharge.message.orderCreated': 'Order created successfully',
  'recharge.message.orderCreateFailed': 'Failed to create recharge order',
  'recharge.message.paymentProcessing': 'Opening payment page, please complete payment...',
  'recharge.message.popupBlocked': 'Cannot open payment window, please check browser popup settings',
  'recharge.message.paymentUrlError': 'Failed to get payment URL',
  'recharge.message.checkoutSessionError': 'Failed to create payment session',
  'recharge.message.paymentError': 'Payment processing failed, please try again later',
  'recharge.message.redirecting': 'Redirecting to payment page, please complete payment...',
  'recharge.message.paymentUrlFailed': 'Payment URL not available',
  'recharge.message.paymentSuccess': 'Payment successful! Balance updated',
  'recharge.message.orderCancelled': 'Order cancelled',
  'recharge.message.paymentFailed': 'Payment failed',
  'recharge.message.orderExpired': 'Expired',
  'recharge.message.queryOrderError': 'Failed to query order status',
  'recharge.message.rechargeError': 'Recharge request failed, please try again later',

  // Orders Page
  'orders.title': 'Order History',
  'orders.subtitle': 'View all your recharge order records and status',
  'orders.refresh': 'Refresh',
  'orders.goToRecharge': 'Recharge',

  // Statistics Cards
  'orders.stats.totalOrders': 'Total Orders',
  'orders.stats.pending': 'Pending',
  'orders.stats.paid': 'Paid',
  'orders.stats.totalAmount': 'Total Recharged',

  // Table Columns
  'orders.table.orderNo': 'Order No.',
  'orders.table.createTime': 'Created At',
  'orders.table.amount': 'Amount',
  'orders.table.paymentMethod': 'Payment Method',
  'orders.table.status': 'Status',
  'orders.table.action': 'Action',
  'orders.table.view': 'View',
  'orders.table.cancel': 'Cancel',
  'orders.table.empty': 'No order records',

  // Order Status
  'orders.status.pending': 'Pending',
  'orders.status.paid': 'Paid',
  'orders.status.success': 'Completed',
  'orders.status.cancelled': 'Cancelled',
  'orders.status.failed': 'Failed',
  'orders.status.expired': 'Expired',
  'orders.status.all': 'All Status',

  // Payment Methods
  'orders.payment.alipay': 'Alipay',
  'orders.payment.wechat': 'WeChat Pay',
  'orders.payment.bank': 'Bank Card',
  'orders.payment.usdt': 'USDT',
  'orders.payment.creem': 'Creem',
  'orders.payment.all': 'All Methods',

  // Currency
  'orders.coin.all': 'All Currencies',

  // Filters
  'orders.filter.title': 'Filter Options',
  'orders.filter.button': 'Filter Orders',
  'orders.filter.reset': 'Reset',
  'orders.filter.apply': 'Apply',
  'orders.filter.orderStatus': 'Order Status',
  'orders.filter.paymentMethod': 'Payment Method',
  'orders.filter.coinType': 'Currency Type',
  'orders.filter.orderNoSearch': 'Search Order No.',
  'orders.filter.quickDate': 'Quick Date',
  'orders.filter.customDate': 'Custom Date',
  'orders.filter.dateTo': 'to',
  'orders.filter.last7Days': 'Last 7 Days',
  'orders.filter.last30Days': 'Last 30 Days',
  'orders.filter.last3Months': 'Last 3 Months',

  // Search and Input
  'orders.search.placeholder': 'Search order number',
  'orders.input.orderNo': 'Enter order number',
  'orders.select.orderStatus': 'Order Status',
  'orders.select.paymentMethod': 'Payment Method',
  'orders.select.coinType': 'Currency',

  // Messages
  'orders.message.fetchError': 'Failed to fetch orders',
  'orders.message.fetchErrorRetry': 'Failed to fetch orders, please try again later',
  'orders.message.statsError': 'Failed to fetch statistics',
  'orders.message.cancelSuccess': 'Order cancelled',
  'orders.message.cancelError': 'Failed to cancel order',
  'orders.message.cancelErrorRetry': 'Failed to cancel order, please try again later',
  'orders.message.viewOrder': 'Order No: {orderNo}',

  // Confirmation Dialog
  'orders.confirm.cancel': 'Are you sure you want to cancel this order?',
  'orders.confirm.ok': 'OK',
  'orders.confirm.cancelButton': 'Cancel',

  // Join Us Page
  'joinUs.seo.title': 'Join PROTX - Pursuit of Excellence',
  'joinUs.seo.description': 'Join the PROTX team and pursue the ultimate user experience and product design with us',
  'joinUs.hero.eyebrow': 'JOIN PROTX',
  'joinUs.hero.title': 'Pursuit of Excellence',
  'joinUs.hero.title2': 'Defining the Future Through Design',
  'joinUs.hero.subtitle': 'PROTX is a team dedicated to crafting the ultimate user experience and product design. We believe every pixel matters, every interaction deserves to be meticulously polished. If you share our relentless pursuit of excellence, join us.',
  'joinUs.hero.cta': 'View Open Positions',
  'joinUs.hero.video': 'Watch Our Story',
  
  // Values
  'joinUs.values.eyebrow': 'OUR VALUES',
  'joinUs.values.title': 'Our Core Values',
  'joinUs.values.subtitle': 'These core values define who we are and how we work together',
  'joinUs.values.innovation.title': 'Innovation-Driven',
  'joinUs.values.innovation.desc': 'We believe innovation is the force that changes the world, encouraging every breakthrough idea.',
  'joinUs.values.collaboration.title': 'Collaborative Success',
  'joinUs.values.collaboration.desc': 'Cross-team collaboration to create extraordinary results together.',
  'joinUs.values.excellence.title': 'Pursuit of Excellence',
  'joinUs.values.excellence.desc': 'Constantly pushing boundaries for the ultimate experience.',
  'joinUs.values.passion.title': 'Passion & Focus',
  'joinUs.values.passion.desc': 'Love for technology, dedication to the product.',
  'joinUs.values.impact.title': 'Making Impact',
  'joinUs.values.impact.desc': 'Empowering everyone\'s creative expression with AI technology.',
  
  // Positions
  'joinUs.positions.eyebrow': 'OPEN POSITIONS',
  'joinUs.positions.title': 'Open Positions',
  'joinUs.positions.subtitle': 'Find the role that fits you and start your new career journey',
  'joinUs.category.engineering': 'Engineering',
  'joinUs.category.product': 'Product & Design',
  'joinUs.category.operations': 'Operations & Marketing',
  'joinUs.position.seniorFrontend': 'Senior Frontend Engineer',
  'joinUs.position.backendEngineer': 'Backend Engineer',
  'joinUs.position.mlEngineer': 'AI/ML Engineer',
  'joinUs.position.productManager': 'Product Manager',
  'joinUs.position.uxDesigner': 'UX Designer',
  'joinUs.position.communityManager': 'Community Manager',
  'joinUs.position.contentCreator': 'Content Creator',
  'joinUs.location.remote': 'Remote',
  'joinUs.location.beijing': 'Beijing',
  'joinUs.location.shanghai': 'Shanghai',
  'joinUs.location.shenzhen': 'Shenzhen',
  'joinUs.type.fulltime': 'Full-time',
  'joinUs.type.parttime': 'Part-time',
  
  // Benefits
  'joinUs.benefits.eyebrow': 'BENEFITS',
  'joinUs.benefits.title': 'What We Offer',
  'joinUs.benefits.subtitle': 'Join us and enjoy comprehensive benefits and support',
  'joinUs.benefit.flexible.title': 'Flexible Work',
  'joinUs.benefit.flexible.desc': 'Flexible hours and remote work options',
  'joinUs.benefit.equity.title': 'Equity Package',
  'joinUs.benefit.equity.desc': 'Grow with the company and share in our success',
  'joinUs.benefit.health.title': 'Health Coverage',
  'joinUs.benefit.health.desc': 'Comprehensive health insurance and wellness benefits',
  'joinUs.benefit.growth.title': 'Career Growth',
  'joinUs.benefit.growth.desc': 'Continuous learning and development opportunities',
  
  // CTA
  'joinUs.cta.title': 'Ready to Get Started?',
  'joinUs.cta.subtitle': 'If you are passionate about our mission, we look forward to hearing from you',
  'joinUs.cta.button': 'Apply Now',
  
  // Application Form
  'joinUs.modal.title': 'Job Application',
  'joinUs.apply.success': 'Application submitted! We will contact you soon.',
  'joinUs.form.name': 'Name',
  'joinUs.form.name.required': 'Please enter your name',
  'joinUs.form.name.placeholder': 'Enter your name',
  'joinUs.form.email': 'Email',
  'joinUs.form.email.required': 'Please enter your email',
  'joinUs.form.email.invalid': 'Please enter a valid email address',
  'joinUs.form.email.placeholder': 'Enter your email',
  'joinUs.form.phone': 'Phone Number',
  'joinUs.form.phone.placeholder': 'Enter your phone number',
  'joinUs.form.experience': 'Work Experience',
  'joinUs.form.experience.placeholder': 'Select your experience level',
  'joinUs.form.experience.0-2': '0-2 years',
  'joinUs.form.experience.3-5': '3-5 years',
  'joinUs.form.experience.5-10': '5-10 years',
  'joinUs.form.experience.10+': '10+ years',
  'joinUs.form.resume': 'Resume',
  'joinUs.form.resume.hint': 'Click or drag file to upload',
  'joinUs.form.resume.format': 'Supports PDF, DOC, DOCX formats',
  'joinUs.form.message': 'Cover Letter',
  'joinUs.form.message.placeholder': 'Tell us about yourself and why you want to join us',
  'joinUs.form.submit': 'Submit Application',
  'joinUs.form.loginTip': 'Log in before submitting to track your application',
  'joinUs.form.goLogin': 'Log In',
  'joinUs.form.resume.sizeLimit': 'File size cannot exceed 10MB',
  
  // My Applications
  'joinUs.myApplications.eyebrow': 'MY APPLICATIONS',
  'joinUs.myApplications.title': 'Application History',
  'joinUs.myApplications.empty': 'No applications yet. Submit your resume now!',
  'joinUs.myApplications.viewDetail': 'View Details',
  'joinUs.myApplications.detailTitle': 'Application Details',
  'joinUs.status.pending': 'Pending',
  'joinUs.status.reviewing': 'Under Review',
  'joinUs.status.interview': 'Interview',
  'joinUs.status.accepted': 'Accepted',
  'joinUs.status.rejected': 'Rejected',
  'joinUs.detail.basicInfo': 'Basic Information',
  'joinUs.detail.positionInfo': 'Position Information',
  'joinUs.detail.position': 'Position Applied',
  'joinUs.detail.category': 'Category',
  'joinUs.detail.location': 'Location',
  'joinUs.detail.applyTime': 'Applied On',
  'joinUs.detail.downloadResume': 'Download Resume',
  'joinUs.detail.status': 'Application Status',

  // About Page
  'about.hero.title1': 'Open Source Core.',
  'about.hero.title2': 'Infinite Possibilities.',
  'about.hero.subtitle1': 'Built on',
  'about.hero.subtitle2': 'and',
  'about.hero.subtitle3': 'ecosystem.',
  'about.hero.description': 'We package the cutting-edge 2025 generative AI tech stack into an ultimate interactive experience.',
  'about.tech.poweredBy': 'Powered by',
  'about.philosophy.title1': 'More than generation.',
  'about.philosophy.title2': 'This is a full-process',
  'about.philosophy.title3': 'creativity engine.',
  'about.philosophy.description': 'From precise control in text-to-image to physics simulation in video generation, we pursue the limits of technology.',
  'about.bento.comfy.title': 'Node-level precision control.',
  'about.bento.comfy.description': 'Built on ComfyUI node-based architecture, supporting ControlNet pose control and IP-Adapter style transfer. We encapsulate complex node logic into intuitive sliders, making every generation exactly as you envision.',
  'about.bento.opensource.title': 'Embrace open source.',
  'about.bento.opensource.description': 'Based on Stable Diffusion 3.5 & XL Turbo. Not only blazing fast generation, but also massive community LoRA model support.',
  'about.bento.video.title': 'DiT Video Architecture.',
  'about.bento.video.description': 'Introducing Diffusion Transformer (DiT) with spatio-temporal attention mechanism, achieving SORA-level physical world simulation.',
  'about.bento.audio.title': 'Audio-visual sync, sensory awakening.',
  'about.bento.audio.description': 'Beyond just visuals. Integrated with the latest audio generation models, supporting Text-to-Audio and automatic video alignment. From sight to sound, building a complete immersive experience.',
  'about.techSection.title': 'Technical Architecture.',
  'about.techSection.description': 'Deep dive into the core engine powering ProductX.',
  'about.techCard.sd.title': 'The foundation of generative art.',
  'about.techCard.sd.description': 'We deeply integrate the latest Stable Diffusion generation models. Through custom VAE and optimized samplers, we achieve 300% faster generation while maintaining exquisite image quality.',
  'about.techCard.spec.baseModel': 'Base Model',
  'about.techCard.spec.resolution': 'Resolution',
  'about.techCard.spec.resolution.value': 'Up to 4K Upscaling',
  'about.techCard.spec.control': 'Control',
  'about.techCard.spec.speed': 'Speed',
  'about.techCard.spec.speed.value': '< 1s (Turbo Mode)',
  'about.techCard.video.title': 'Next-gen video physics engine.',
  'about.techCard.video.description': 'Abandoning traditional 2D animation logic, adopting the latest 2025 DiT (Diffusion Transformer) architecture. The model understands lighting, gravity, and motion physics, generating not just videos, but physically accurate dynamic worlds.',
  'about.techCard.spec.architecture': 'Architecture',
  'about.techCard.spec.frameRate': 'Frame Rate',
  'about.techCard.spec.frameRate.value': '24 / 60 FPS Interpolation',
  'about.techCard.spec.consistency': 'Consistency',
  'about.techCard.spec.consistency.value': 'High Temporal Stability',
  'about.techCard.spec.length': 'Length',
  'about.techCard.spec.length.value': 'Infinite Loop Extension',
  'about.techCard.img2img.title': 'Image-to-image & style transfer.',
  'about.techCard.img2img.description': 'Using IP-Adapter and T2I-Adapter technologies, we achieve zero-shot style transfer. Upload a reference image to instantly replicate its composition, lighting, and artistic style, unleashing infinite creative possibilities.',
  'about.techCard.spec.technology': 'Technology',
  'about.techCard.spec.precision': 'Precision',
  'about.techCard.spec.precision.value': 'Pixel-Perfect Inpainting',
  'about.cta.title': 'Ready to experience the future?',
  'about.cta.description': 'Join the ranks of professional creators and unleash the ultimate potential of AI.',
  'about.cta.button.start': 'Get Started',
  'about.cta.button.docs': 'Read Documentation',
  
  // Community
  'community.explore.title': 'Explore Communities',
  'community.explore.subtitle': 'Discover inspiration, remix workflows, and connect with thousands of AI creators.',
  'community.posts': '{count} posts',
  'community.empty': 'No community channels',
  'community.loadFailed': 'Failed to load',
  'community.noPosts': 'No posts yet',
  'community.challenge.loadFailed': 'Failed to load challenge data',
  
  // Common messages
  'common.loadFailed': 'Failed to load',
  'common.operationFailed': 'Operation failed',
  'common.error': 'Operation failed',
  'common.publish': 'Publish',
  'common.back': 'Back',
  'common.backToCommunity': 'Back to Community',
  'common.copy': 'Copy',
  'common.copied': 'Copied',
  'common.like': 'Like',
  'common.unlike': 'Unlike',
  'common.save': 'Save',
  'common.follow': 'Follow',
  'common.processing': 'Processing...',
  'common.viewCount': '{count} Views',
  'common.loadMore': 'Load More',
  'common.search': 'Search...',
  'common.notFound': 'Not Found',
  'common.description': 'Description',
  
  // User related
  'user.followSuccess': 'Followed successfully',
  'user.unfollowSuccess': 'Unfollowed successfully',
  'user.following': 'Following',
  'user.mutual_follow': 'Mutual',
  
  // Post related
  'post.untitled': 'Untitled Creation',
  'post.prompt': 'Prompt',
  'post.negativePrompt': 'Negative Prompt',
  'post.details': 'Details',
  'post.model': 'Model',
  'post.resolution': 'Resolution',
  'post.steps': 'Steps',
  'post.cfgScale': 'Guidance Scale',
  'post.remix': 'Remix / Try this',
  
  // Challenge related
  'challenge.status.upcoming': 'Upcoming',
  'challenge.status.live': 'Live Now',
  'challenge.status.voting': 'Voting',
  'challenge.status.ended': 'Ended',
  'challenge.status.unknown': 'Unknown',
  'challenge.allChallenges': 'All Challenges',
  'challenge.entriesCount': '{count} Entries',
  'challenge.tab.submissions': 'Submissions',
  'challenge.tab.rules': 'Rules & Info',
  'challenge.requirements': 'Requirements',
  'challenge.req.original': 'Original creations only.',
  'challenge.req.model': 'Must use model: {model}',
  'challenge.req.tags': 'Must include tags:',
  'challenge.req.resolution': 'Resolution must be at least 1024x1024.',
  'challenge.req.nsfw': 'No NSFW content.',
  'challenge.timeRemaining': 'Time Remaining',
  'challenge.startsIn': 'Starts In',
  'challenge.notStarted': 'Challenge Not Started',
  'challenge.closed': 'Challenge Closed',
  'challenge.submitEntry': 'Submit Entry',
  'challenge.viewWinners': 'View Winners',
  'challenge.readRulesTip': 'Read the rules before submitting',
  'challenge.prizePool': 'Prize Pool',
  'challenge.totalValue': 'Total Value',
  'challenge.rank.1st': '1st Place',
  'challenge.rank.2nd': '2nd Place',
  'challenge.rank.3rd': '3rd Place',
  'challenge.share': 'Share Challenge',
  'challenge.noEntries': 'No entries yet. Be the first!',
  'challenge.noChallenges': 'No challenges found',
  // MediaTools
  'mediaTools.tab.imageCompress': 'Image Compress',
  'mediaTools.tab.videoCompress': 'Video Compress',
  'mediaTools.tab.audioCompress': 'Audio Compress',
  'mediaTools.tab.formatConvert': 'Format Convert',
  // ImageCompress
  'imageCompress.title': 'Image Compressor Pro',
  'imageCompress.subtitle': 'Intelligent compression for professionals',
  'imageCompress.upload': 'Upload Images',
  'imageCompress.addImages': 'Add Images',
  'imageCompress.uploadToStart': 'Upload images to get started',
  'imageCompress.settings': 'Settings',
  'imageCompress.clearAll': 'Clear All',
  'imageCompress.totalSavings': 'Total Savings',
  'imageCompress.totalSize': 'Total Size',
  'imageCompress.quality': 'Quality',
  'imageCompress.resize': 'Resize',
  'imageCompress.scalePercent': 'Scale %',
  'imageCompress.customPx': 'Custom px',
  'imageCompress.presetSize': 'Preset size',
  'imageCompress.width': 'Width',
  'imageCompress.height': 'Height',
  'imageCompress.format': 'Format',
  'imageCompress.format.auto': 'Auto (Original)',
  'imageCompress.format.jpeg': 'JPEG (Photo)',
  'imageCompress.format.png': 'PNG (Lossless)',
  'imageCompress.format.webp': 'WebP (Best)',
  'imageCompress.pngLossless': 'PNG is lossless. Quality slider hidden.',
  'imageCompress.cacheSettings': 'Cache Settings',
  'imageCompress.cacheTooltip': 'When enabled, uploaded images will be saved to browser cache and restored after page refresh.',
  'imageCompress.saveToCache': 'Save images to browser cache',
  'imageCompress.batchProcessing': 'Batch Processing',
  'imageCompress.batchTooltip': 'When enabled, compression will be applied to all {count} images with current settings.',
  'imageCompress.applyToAll': 'Apply settings to all images ({count})',
  'imageCompress.compress': 'Apply & Compress',
  'imageCompress.compressAll': 'Apply & Compress All ({count})',
  'imageCompress.compressing': 'Compressing...',
  'imageCompress.compressAllProgress': 'Compressing {count} images...',
  'imageCompress.download': 'Download Image',
  'imageCompress.downloadAll': 'Download All ({count})',
  'imageCompress.downloadAllCheckbox': 'Download all {count} images',
  'imageCompress.original': 'Original',
  'imageCompress.compressed': 'Compressed',
  // Messages
  'imageCompress.message.compressed': 'Compressed!',
  'imageCompress.message.larger': 'Output is larger. Try reducing quality.',
  'imageCompress.message.failed': 'Compression failed',
  'imageCompress.message.batchSuccess': 'Successfully compressed {success} image(s){failed}',
  'imageCompress.message.batchFailed': 'All compressions failed',
  'imageCompress.message.noImagesToDownload': 'No compressed images to download',
  'imageCompress.message.downloading': 'Downloading {count} image(s)...',
  // Preset sizes
  'imageCompress.preset.instagramPost': 'Instagram Post (1:1)',
  'imageCompress.preset.square': 'Square (1:1)',
  'imageCompress.preset.facebookCover': 'Facebook Cover (16:9)',
  'imageCompress.preset.twitterHeader': 'Twitter Header (3:1)',
  'imageCompress.preset.youtubeThumbnail': 'YouTube Thumbnail (16:9)',
  'imageCompress.preset.facebookPost': 'Facebook Post (1.91:1)',
  'imageCompress.preset.instagramStory': 'Instagram Story (9:16)',
  'imageCompress.preset.tiktok': 'TikTok (9:16)',
  'imageCompress.preset.4kUHD': '4K UHD (16:9)',
  'imageCompress.preset.2kQHD': '2K QHD (16:9)',
  'imageCompress.preset.fullHD': 'Full HD (16:9)',
  'imageCompress.preset.hd': 'HD (16:9)',
  'imageCompress.preset.landscape16:9': '16:9 Landscape',
  'imageCompress.preset.classic4:3': '4:3 Classic',
  'imageCompress.preset.photo3:2': '3:2 Photo',
  'imageCompress.preset.ultrawide21:9': '21:9 Ultrawide',
  'imageCompress.preset.a4Portrait': 'A4 Portrait (8.27×11.69")',
  'imageCompress.preset.a4Landscape': 'A4 Landscape (11.69×8.27")',
  'imageCompress.preset.letterPortrait': 'Letter Portrait (8.5×11")',
  // VideoCompress
  'videoCompress.title': 'Professional Video Compressor',
  'videoCompress.subtitle': 'Browser-side compression, privacy protected',
  'videoCompress.upload': 'Upload Video',
  'videoCompress.uploadToStart': 'Upload video to start compression',
  'videoCompress.settings': 'Settings',
  'videoCompress.clearAll': 'Clear All',
  'videoCompress.totalSavings': 'Total Savings',
  'videoCompress.totalSize': 'Total Size',
  'videoCompress.videoInfo': 'Video Info',
  'videoCompress.quality': 'Quality',
  'videoCompress.crf': 'CRF (Quality)',
  'videoCompress.crfTooltip': 'Lower CRF means better quality, 18-28 is commonly used',
  'videoCompress.bitrate': 'Bitrate',
  'videoCompress.bitrateNote': 'Selecting bitrate will override CRF setting',
  'videoCompress.resolution': 'Resolution',
  'videoCompress.fps': 'Frame Rate',
  'videoCompress.fpsPlaceholder': 'Keep original frame rate',
  'videoCompress.format': 'Format',
  'videoCompress.compress': 'Start Compress',
  'videoCompress.compressing': 'Compressing...',
  'videoCompress.compressingProgress': 'Compressing video, please wait...',
  'videoCompress.download': 'Download Video',
  'videoCompress.original': 'Original',
  'videoCompress.compressed': 'Compressed',
  // Messages
  'videoCompress.message.compressed': 'Compressed successfully!',
  'videoCompress.message.failed': 'Compression failed, please try again',
  'videoCompress.message.invalidFile': 'Please select a video file',
  'videoCompress.message.loadFailed': 'Failed to load video',
  'videoCompress.message.downloading': 'Starting download',
  // AudioCompress
  'audioCompress.title': 'Professional Audio Compression Tool',
  'audioCompress.subtitle': 'Browser-based compression, privacy protected',
  'audioCompress.upload': 'Upload Audio',
  'audioCompress.uploadNew': 'Click to upload new audio',
  'audioCompress.uploadToStart': 'Upload audio to start compression',
  'audioCompress.settings': 'Settings',
  'audioCompress.clearAll': 'Clear All',
  'audioCompress.totalSavings': 'Space Saved',
  'audioCompress.totalSize': 'Total Size',
  'audioCompress.audioInfo': 'Audio Info',
  'audioCompress.quality': 'Quality',
  'audioCompress.bitrate': 'Bitrate',
  'audioCompress.bitrate.320': '320 kbps (Highest Quality)',
  'audioCompress.bitrate.256': '256 kbps (High Quality)',
  'audioCompress.bitrate.192': '192 kbps (Standard Quality)',
  'audioCompress.bitrate.128': '128 kbps (Medium Quality)',
  'audioCompress.bitrate.96': '96 kbps (Low Quality)',
  'audioCompress.bitrate.64': '64 kbps (Lowest Quality)',
  'audioCompress.format': 'Format',
  'audioCompress.format.mp3': 'MP3 (Recommended)',
  'audioCompress.format.ogg': 'OGG',
  'audioCompress.format.aac': 'AAC',
  'audioCompress.format.wav': 'WAV',
  'audioCompress.sampleRate': 'Sample Rate',
  'audioCompress.sampleRate.48000': '48000 Hz',
  'audioCompress.sampleRate.44100': '44100 Hz (CD Quality)',
  'audioCompress.sampleRate.32000': '32000 Hz',
  'audioCompress.sampleRate.22050': '22050 Hz',
  'audioCompress.sampleRate.16000': '16000 Hz',
  'audioCompress.compress': 'Start Compression',
  'audioCompress.compressing': 'Compressing...',
  'audioCompress.download': 'Download Audio',
  // AudioCompress Messages
  'audioCompress.message.compressed': 'Compressed successfully!',
  'audioCompress.message.failed': 'Compression failed, please try again',
  'audioCompress.message.invalidFile': 'Please select an audio file!',
  'audioCompress.message.loadError': 'Failed to load audio file',
  
  // Settings
  'settings.title': 'System Settings',
  'settings.description': 'Personalize your AI generation platform experience',
  // Notifications
  'settings.notifications.title': 'Notification Settings',
  'settings.notifications.description': 'Manage how you receive notifications',
  'settings.notifications.email': 'Email Notifications',
  'settings.notifications.emailDesc': 'Receive important updates and task completion emails',
  'settings.notifications.push': 'Push Notifications',
  'settings.notifications.pushDesc': 'Receive real-time push messages',
  'settings.notifications.sound': 'Sound Alerts',
  'settings.notifications.soundDesc': 'Play a sound when notifications arrive',
  'settings.notifications.volume': 'Notification Volume',
  'settings.notifications.volumeDesc': 'Adjust the volume of notification sounds',
  'settings.notifications.marketing': 'Marketing',
  'settings.notifications.marketingDesc': 'Receive platform events and promotional information',
  // Interface
  'settings.interface.title': 'Interface Appearance',
  'settings.interface.description': 'Customize the interface display',
  'settings.interface.theme': 'Theme Mode',
  'settings.interface.themeDesc': 'Choose your preferred interface theme',
  'settings.interface.language': 'Language',
  'settings.interface.languageDesc': 'Select interface display language',
  'settings.interface.animation': 'Animation Effects',
  'settings.interface.animationDesc': 'Enable interface transition animations',
  'settings.interface.tips': 'Beginner Tips',
  'settings.interface.tipsDesc': 'Show feature guides and tips',
  'settings.theme.light': 'Light',
  'settings.theme.dark': 'Dark',
  'settings.theme.auto': 'Auto',
  // AI Settings
  'settings.ai.title': 'AI Generation Settings',
  'settings.ai.description': 'Optimize AI generation effects and performance',
  'settings.ai.autoOptimize': 'Smart Optimization',
  'settings.ai.autoOptimizeDesc': 'AI automatically optimizes generation parameters for best results',
  'settings.ai.quality': 'Generation Quality',
  'settings.ai.qualityDesc': 'Balance speed and quality',
  'settings.ai.cloudSync': 'Cloud Sync',
  'settings.ai.cloudSyncDesc': 'Automatically sync works to cloud',
  'settings.ai.autoSave': 'Auto Save',
  'settings.ai.autoSaveDesc': 'Automatically save results after generation',
  'settings.ai.safetyFilter': 'Content Safety Filter',
  'settings.ai.safetyFilterDesc': 'Automatically filter inappropriate content',
  'settings.ai.watermark': 'Add Watermark',
  'settings.ai.watermarkDesc': 'Automatically add watermark to generated works',
  'settings.ai.promptSuggestions': 'Prompt Suggestions',
  'settings.ai.promptSuggestionsDesc': 'Smart recommendations for prompt optimization',
  'settings.quality.fast': 'Fast',
  'settings.quality.balanced': 'Balanced',
  'settings.quality.high': 'High Quality',
  // Privacy
  'settings.privacy.title': 'Privacy & Security',
  'settings.privacy.description': 'Protect your personal information',
  'settings.privacy.profile': 'Profile Visibility',
  'settings.privacy.profileDesc': 'Allow other users to view your profile',
  'settings.privacy.activity': 'Show Activity Status',
  'settings.privacy.activityDesc': 'Let friends see your online status',
  'settings.privacy.analytics': 'Analytics Data Collection',
  'settings.privacy.analyticsDesc': 'Help us improve product experience',
  'settings.privacy.showWorks': 'Works Visibility',
  'settings.privacy.showWorksDesc': 'Allow other users to view your works',
  'settings.privacy.allowComments': 'Allow Comments',
  'settings.privacy.allowCommentsDesc': 'Allow other users to comment on your works',
  'settings.privacy.allowDownload': 'Allow Download',
  'settings.privacy.allowDownloadDesc': 'Allow other users to download your works',
  // Performance
  'settings.performance.title': 'Performance Optimization',
  'settings.performance.description': 'Adjust system performance and resource usage',
  'settings.performance.hardware': 'Hardware Acceleration',
  'settings.performance.hardwareDesc': 'Use GPU acceleration for rendering',
  'settings.performance.preview': 'Preview Quality',
  'settings.performance.previewDesc': 'Quality level of preview images',
  'settings.performance.autoClean': 'Auto Clean Cache',
  'settings.performance.autoCleanDesc': 'Regularly clean temporary files',
  'settings.performance.imageCompression': 'Image Compression',
  'settings.performance.imageCompressionDesc': 'Automatically compress uploaded images',
  'settings.performance.lazyLoading': 'Lazy Loading',
  'settings.performance.lazyLoadingDesc': 'Delay loading page content',
  'settings.preview.low': 'Low',
  'settings.preview.medium': 'Medium',
  'settings.preview.high': 'High',
  // Workflow
  'settings.workflow.title': 'Workflow Settings',
  'settings.workflow.description': 'Customize AI generation workflow',
  'settings.workflow.resolution': 'Default Resolution',
  'settings.workflow.resolutionDesc': 'Default size for image generation',
  'settings.workflow.saveHistory': 'Save History',
  'settings.workflow.saveHistoryDesc': 'Save generation parameters and prompt history',
  'settings.workflow.autoTag': 'Smart Tags',
  'settings.workflow.autoTagDesc': 'Automatically add tags to works',
  'settings.workflow.template': 'Template Feature',
  'settings.workflow.templateDesc': 'Enable workflow templates',
  // File Management
  'settings.file.title': 'File Management',
  'settings.file.description': 'Manage file storage and backup',
  'settings.file.autoBackup': 'Auto Backup',
  'settings.file.autoBackupDesc': 'Automatically backup important files',
  'settings.file.backupFrequency': 'Backup Frequency',
  'settings.file.backupFrequencyDesc': 'Select backup frequency',
  'settings.file.realtime': 'Real-time',
  'settings.file.daily': 'Daily',
  'settings.file.weekly': 'Weekly',
  'settings.file.autoOrganize': 'Smart Organization',
  'settings.file.autoOrganizeDesc': 'Automatically categorize and organize files',
  'settings.file.defaultFormat': 'Default Format',
  'settings.file.defaultFormatDesc': 'Default format for saving files',
  // Social
  'settings.social.title': 'Social Interaction',
  'settings.social.description': 'Manage social features and interaction permissions',
  'settings.social.allowFollow': 'Allow Follow',
  'settings.social.allowFollowDesc': 'Allow other users to follow you',
  'settings.social.allowMessage': 'Allow Messages',
  'settings.social.allowMessageDesc': 'Allow other users to send you messages',
  'settings.social.likeNotify': 'Like Notifications',
  'settings.social.likeNotifyDesc': 'Notify when works are liked',
  'settings.social.mentionNotify': 'Mention Notifications',
  'settings.social.mentionNotifyDesc': 'Receive notifications when mentioned',
  // Security
  'settings.security.title': 'Account Security',
  'settings.security.description': 'Enhance account security protection',
  'settings.security.twoFactor': 'Two-Factor Authentication',
  'settings.security.twoFactorDesc': 'Add an extra layer of security verification',
  'settings.security.loginNotify': 'Login Notifications',
  'settings.security.loginNotifyDesc': 'Notify when logging in from new devices',
  'settings.security.deviceVerify': 'Device Verification',
  'settings.security.deviceVerifyDesc': 'Unauthorized devices require verification',
  'settings.security.autoLogout': 'Auto Logout on Idle',
  'settings.security.autoLogoutDesc': 'Automatically logout after long inactivity',
  // Actions
  'settings.button.save': 'Save Settings',
  'settings.button.reset': 'Reset to Default',
  'settings.badge.on': 'On',
  'settings.badge.recommended': 'Recommended',
  // Messages
  'settings.message.saveSuccess': 'Settings saved',
  'settings.message.autoSaved': 'Settings auto-saved',
  'settings.message.saveFailed': 'Failed to save, please try again',
  'settings.message.resetSuccess': 'Settings reset to default',
  'settings.autoSaveHint': 'Settings will be saved automatically',
  'settings.confirm.resetTitle': 'Confirm Reset',
  'settings.confirm.resetContent': 'Are you sure you want to reset all settings to default?',
  'settings.confirm.reset': 'Reset',
  'settings.confirm.cancel': 'Cancel',

  // Prompt Version History
  'prompt.version.label.prompt': 'Prompt',
  'prompt.version.label.negativePrompt': 'Negative Prompt',
  'prompt.version.label.result': 'Result',
}; 